/* globals window */
/* eslint-disable quote-props */
/* eslint-disable angular/window-service */

(function iife() {
	"use strict";

	var common = {
		archiveNoun: "Archive",
		createNewExam: "+ Create new exam",
		exams: "Exams",
		examTemplates: "Exam Templates",
		rubrics: "Rubrics",
		dateModified: "Date modified",
		startTime: "Start time",
		title: "Title",
		cancel: "Cancel",
		remove: "Remove",
		on: "On",
		off: "Off",
		add: "Add",
		edit: "Edit",
		save: "Save",
		student: "Student",
		students: "Students",
		question: "Question",
		questions: "Questions",
		studentCode: {
			base: "Student Code",
			new: "New Student Code",
		},
		other: "Other",
		upload: "Upload",
		errors: {
			invalidEmail: "Invalid e-mail address",
		},
	};

	window.DX.locales.en = {
		"Required": "Required",
		"LogIn": "Log in",
		"CreateAccount": "Create account",
		"ForgotPassword": "Forgot your password?",
		"LogInWithSkolon": "Log in with Skolon",
		"AboutTheCompany": "About the company",
		"TermsOfService": "terms of service",
		"PrivacyPolicy": "privacy policy",
		"CookiePolicy": "cookie policy",
		"RegisterTerms_part1": "I agree to Digiexams ",
		"RegisterDone_part1": "Before you can log in to your account you need to verify your e-mail address.",
		"RegisterDone_part2": "Open the link in the e-mail sent to you to verify it.",
		"HowWeWorkWithData_Intro": "For an easy to read write-up on how we work with your data, see the page:",
		"HowWeWorkWithData_LinkTitle": "How we work with data",
		"ChangeRole": "Change role",
		"Overview": "Overview",
		"Support": "Support",
		"ErrorMessage": "Error message",
		"Email": "E-mail",
		"Emails": "E-mails",
		"ConfirmEmail": "Confirm e-mail",
		"FirstName": "First name",
		"LastName": "Last name",
		"Password": "Password",
		"ConfirmPassword": "Confirm password",
		"Back": "Back",
		"ChoosePlaceToLogin": "Choose place to log in to",
		"ChooseAndLogIn": "Choose and log in",
		"Send": "Send",
		"ForgotPassword_String1": "Enter your e-mail and we will send you a link that you can use to reset your password.",
		"YourAccountHasBeenCreated": "Your account has been created",
		"ReturnToLogIn": "Return to log in",
		"SessionExpiredLogInToContinue": "Your session has expired. Log in again to continue where you left off.",
		"LoginFailed": "Login failed",
		"LoginFailedDescription": "Login failed, e-mail or password is incorrect.",
		"LoginFailedDescription.Timeout": "The login attempt timed out when trying to contact the Digiexam servers, please try again.",
		"LoginFailedDescription.Throttled": "You have attempted to login too many times during a 3 minute period. Wait a few minutes and try again.",
		"PasswordResetLinkHasBeenSent": "Reset password link sent",
		"ForgotPasswordLinkRequest_String1": "If a user exists with the e-mail address, we will send a link in an e-mail that you open to choose a new password for your account.",
		"ForgotPasswordLinkRequest_String2": "You may need to look in your spam folder to find the email.",
		"ForgotPassword_String3": "Enter a new password for your account.",
		"ForgotPassword_String4": "You can now log in to your account using your new password.",
		"SetPassword_String3": "Enter a password for your new account.",
		"SetPassword_String4": "You can now log in to your account.",
		"YourAccountIsNowBeingVerified": "Your account is now being activated",
		"ItMightTakeAWhile": "It might take a little while, please hold.",
		"PleaseWait": "Please stand by",
		"YourAccountIsNowVerified": "Your account is now activated!",
		"NotVerified": "E-mail address not verified",
		"VerificationError_WrongCode": "Invalid verification code.",
		"AnErrorHasOccurred": "An error has occurred",
		"RequiredField": "Necessary field",
		"MustBeLongerThan1Char": "Must be greater than 1 character",
		"MustBeLongerThan5Chars": "Must be greater than 7 characters",
		"MustBeValidEmail": "Must be a valid e-mail",
		"InvalidEmail": common.errors.invalidEmail,
		"EmailsAreNotAMatch": "The e-mails doesn't match",
		"YouCantShareToYourOwnMail": "You can't share to your own e-mail address",
		"PasswordTooShort": "Password must be at least 8 characters",
		"PasswordTooLong": "Password cannot be longer than 100 characters",
		"PasswordWhitespace": "Password cannot contain blank characters",
		"PasswordsAreNotAMatch": "The passwords doesn't match",
		"PasswordCanNotBeOld": "Can't be the same as your old password",
		"PasswordCommon": "Password is not complex enough or is too common. Try a more unique password",
		"WrongPassword": "Wrong password",
		"Optional": "Optional",
		"EmailAlreadyRegistered": "This e-mail is already registered",
		"InviteEmailAlreadyRegistered": "A user with the e-mail {0} is already registered",
		"Overview_String1": "You have not taken part in any classes yet, click on the button below to do that.",
		"ShowExamLibrary": "Show library",
		"HideExamLibrary": "Hide library",
		"YourExams": "Your exams at {0}",
		"YourExamLibrary": "Your exam library",
		"StartNewExam": "Start new exam",
		"InformationBox1": "To start a new exam, open the ",
		"InformationBox2": "Digiexam app ",
		"InformationBox3": "on your computer. You can download and install the app ",
		"InformationBox4": "here",
		"StartClientButton": "Open Digiexam app",
		"RefreshExamList": "Refresh exam list",
		"Date": "Date",
		"Course": "Course",
		"Courses": "Courses",
		"Status": "Status",
		"Result": "Result",
		"NotPlanned": "Not planned",
		"EnterANewClass": "Take part in a new class",
		"ThereAreNoActiveExams": "There are no active exams",
		"UnknownError": "Unknown error",
		"UnknownErrorTryAgain": "An unknown error occured, please try again.",
		"Ok": "Ok",
		"OkIUnderstand": "Ok, I understand",
		"ThereAreNoUngradedExams": "There are no ungraded exams",
		"ConnectionToServerWasInterrupted": "The connection to our server was interrupted",
		"ConnectionError_String1": "You have lost connection to our server. This prevents activities that you currently are working on from being saved. ",
		"ConnectionError_String2": "Be careful to not lose any data.",
		"ConnectionError_String3": "The reasons for this connection loss can be one of many, but most probable are;",
		"ConnectionError_String4": "Your computer has lost connection to the Internet, check your network cable or try to reconnect to the WiFi.",
		"ConnectionError_String5": "There are disturbances in the network between you and our servers.",
		"ConnectionError_String6": "Our servers are under high load.",
		"ConnectionError_String7": "Do not close the browser tab if you have unsaved data, try to contact your IT-staff and ask if they can resolve this problem.",
		"ConnectionError_String8": "This box will close when the connection is working as intended.",
		"Home": "Home",
		"Classroom": "Classroom",
		"CreateRole": "Create role",
		"AssignRole": "Assign role",
		"LogOut": "Log out",
		"Settings": "Settings",
		"ChangePersonalData": "Change personal data",
		"InformationSaved": "Information saved!",
		"ChangePassword": "Change password",
		"SetPassword": "Set password",
		"Save": common.save,
		"SaveX": "Save {0}",
		"SaveAndClose": "Save and close",
		"SaveChanges": "Save changes",
		"YourCurrentPassword": "Your current password",
		"NewPassword": "New password",
		"ConfirmNewPassword": "Confirm new password",
		"YourPasswordHasBeenChanged": "Your password has been changed!",
		"YourPasswordHasBeenSet": "Your password has been set!",
		"PlanExam": "Plan exam",
		"PlanExams": "Plan exams",
		"ThereAreNoExams": "There are no exams",
		"RemoveExam": "Remove exam",
		"RemoveSharedExam": "Remove shared exam",
		"RemoveRubric": "Remove rubric",
		"RemoveGradingShare": "Remove your grading share",
		"DoYouWantToRemoveGradingShareForExam": "Do you want to remove your grading share for exam {0}",
		"YesRemoveShare": "Yes, remove grading share",
		"ThePersonWhoSharedTheExamWillStillHaveAccessToIt": "The person who shared the exam will still be able to access it.",
		"EditExam": "Edit exam",
		"UploadOfflineAnswerFile": "Upload offline answer file",
		"UploadOfflineAnswerFile_Description": "Upload offline answer files for students who could not hand in their answers online.",
		"UploadOfflineAnswerFile_FileFormats": "Allowed file types are .zip and .dxr",
		"UploadOfflineAnswerFile_Error": "One or more files could not be uploaded",
		"UploadOfflineAnswerFile_Success": "All files have been uploaded",
		"UploadOfflineAnswerFile_DropOrClickUpload": "Drop offline answer files here or click to add them.",
		"UploadOfflineAnswerFile_UnpublishToUpload": "The exam is published, unpublish the exam to upload offline answer files.",
		"Files": "Files",
		"Filename": "Filename",
		"StudentAnswers": "Student answers",
		"Students": common.students,
		"Name": "Name",
		"StudentCode": common.studentCode.base,
		"NewStudentCode": common.studentCode.new,
		"Edit": common.edit,
		"Monitor": "Monitor",
		"Schedule": "Schedule",
		"Reschedule": "Reschedule",
		"Start": "Start",
		"ShowMoreExamActions": "Show more exam actions",
		"RemoveStudent": "Remove student",
		"RemoveStudentFromClass": "Remove the student from the class",
		"EditStudent": "Edit student",
		"EditStudentCode": "Edit student code",
		"NoStudentsHaveRegisteredYet": "No students have been registered yet.",
		"ClassIsExternallyManaged": "This class is externally managed and cannot be modified within Digiexam.",
		"ViewClass_String5": "You can send a class to the archive if it's no longer relevant.",
		"CouldNotFindClass": "Could not find class",
		"CouldNotFindClassYouSearchedFor": "Could not find the class you searched for.",
		"Archive": "Archive",
		"Archive.noun": "Archive",
		"Dearchive": "Dearchive",
		"Group": "Group",
		"Class": "Class",
		"Classes": "Classes",
		"Hide": "Hide",
		"Show": "Show",
		"DoYouReallyWantToDoThis": "Do you really want to do this?",
		"DoYouWannaRemoveX": "Do you really want to remove \"{0}\"?",
		"DoYouWannaRemoveExam": "Are you sure you want to remove \"{0}\"? This action cannot be undone.",
		"DoYouWannaRemoveStudent": "Do you really want to remove the following student?",
		"DoYouWannaRemoveStudents": "Do you really want to remove the following students?",
		"Confirm": "Confirm",
		"Cancel": common.cancel,
		"ArchiveClass": "Archive class",
		"YouCanFindYourArchivedClassesInArchive": "You can find your archived classes in the archive. You can always undo the archivation.",
		"ClassWillNowBeDearchived": "The class will be found under your classes again.",
		"DearchiveClass": "Dearchive class",
		"YesDearchive": "Yes, dearchive",
		"NoCancel": "No, cancel",
		"Library": "Library",
		"Subjects": "Subjects",
		"Type": "Type",
		"LatestWeek": "Latest week",
		"LatestMonth": "Latest month",
		"LatestYear": "Latest year",
		"SpecifyDate": "Specify date",
		"From": "From",
		"To": "To",
		"Add": common.add,
		"AddX": "Add {0}",
		"NoFiltersActive": "No filters added",
		"ClearAllFilters": "Clear all filters",
		"Clear": "Clear",
		"YourLibraryIsEmptyCreateExams": "You have not created any exams.",
		"YourLibraryIsEmptyCreateRubrics": "Your have not created any rubrics.",
		"Between": "Between",
		"And": "and",
		"Tag": "tag",
		"Matching": "matching",
		"NamelessExam": "Nameless exam",
		"NamelessRubric": "Nameless rubric",
		"Preview": "Preview",
		"PreviewAndPrint": "Preview / Print",
		"GoToGrading": "Go to grading",
		"PreviewProgress": "Preview progress",
		"ExamMonitoringView": "Exam monitoring view",
		"Select": "Select",
		"SelectThisExam": "Select this exam",
		"Question": common.question,
		"Questions": common.questions,
		"QuestionX": "Question {0}",
		"Close": "Close",
		"YourClasses": "Your classes",
		"YourClasses.NoClass": "You have not created any classes, create one by clicking the button above to get started with planned exams.",
		"AddQuestion": "Add question",
		"CreateExam": "Create exam",
		"CreateRubric": "Create rubric",
		"CreateClass": "Create class",
		"CreateCourse": "Create course",
		"CreateGroup": "Create group",
		"YourCourses": "Your courses",
		"ArchivedClasses": "Archived classes",
		"FilterClasses": "Filter classes",
		"FilterCourses": "Filter courses",
		"ArchivedGroups": "Archived groups",
		"DragClassHere": "Drag class here",
		"Original": "Original",
		"Copy": "Copy",
		"Draft": "Draft",
		"CanNotBeEmpty": "Can't be empty",
		"CanNotBeLongerThanXChars": "Can't be longer than {0} characters",
		"InputLengthLimitReached": "You have reached the {0}-character limit",
		"Title": common.title,
		"LastModified": "Last modified",
		"LastCreated": "Last created",
		"SortBy": "Sort by",
		"OrderBy": "Order by",
		"PublicExamDescription": "Public exam description",
		"PublicExamDescriptionOptional": "Public exam description (optional)",
		"ProfilePicture": "Profile picture",
		"AllowBlank": "Allow blank",
		"AllowSpellcheckForAllStudents": "Allow all students to use spell check",
		"Saved": "Saved",
		"SavedHMS": "Saved ({0}:{1}:{2})",
		"DraftSaved": "Draft saved",
		"SaveAsNew": "Save as new",
		"NotVisibleToStudents": "Not visible to students",
		"YourOwnNotes": "Your notes (optional)",
		"CopyLastQuestion": "Copy last question",
		"MaxLengthsWords": "Max length (words)",
		"LimitAnswerLength": "Limit answer length",
		"NoLimit": "No limit",
		"SoftLimit": "Soft limit",
		"HardLimit": "Hard limit",
		"MaxPoints": "Max points",
		"GradingInformation": "Grading information",
		"Subject": "Subject",
		"TakePartInAClass": "Take part in a class",
		"EnterCodeTeacherProvided": "Enter the code provided by the teacher",
		"EnterCode": "Enter code",
		"TakePartInClass": "Take part in class",
		"YouAreTryingToEnterThisClass": "You are trying to enter this class",
		"TypeInYourStudentCodeFor": "Enter the student code for",
		"AndConfirmYourChoice": "and confirm your choice",
		"Accept": "Accept",
		"FaultyCode": "Faulty code.",
		"RemindMeLater": "Remind me later",
		"RegistrationIsClosed": "The registration is closed.",
		"UploadStatus.HandedIn": "Handed in",
		"UploadStatus.WrongExam": "Wrong exam",
		"UploadStatus.InvalidEmail": common.errors.invalidEmail,
		"UploadStatus.StudentNotFound": "This student does not have an account yet. One must be created by an account manager first.",
		"ChangeLanguage": "Change language",
		"Language": "Language",
		"ChooseClass": "Choose class",
		"YouHaveNoClassesOrGroupsToManage": "You have no classes or groups to manage.",
		"StopExam": "Stop exam",
		"DownloadGradesSpreadsheet": "Download grades spreadsheet",
		"DownloadGradesSpreadsheetIndicateUnanswered": "Indicate unanswered questions with \"-\"",
		"OpenGrading": "Open grading",
		"GradeExam": "Grade exam",
		"For": "For",
		"StartExam": "Start exam",
		"Tests": "Tests",
		"FinishedExams": "Completed exams",
		"ChooseAnotherClass": "Choose another class",
		"Locked": "Locked",
		"Unlocked": "Unlocked",
		"Yes": "Yes",
		"No": "No",
		"NotDigitally": "Not digitally",
		"OngoingExam": "Ongoing exam",
		"HaveOpenedExam": "have opened the exam",
		"HaveSubmitted": "have submitted",
		"NotStartedStudents": "Not started students",
		"DoYouWantToEndTheOngoingExam": "Do you want to end the ongoing exam?",
		"YesEndExam": "Yes, end the exam",
		"DeleteExam": "Delete exam",
		"DeleteExams": "Delete exams",
		"DeleteTemplateExam": "Delete template exam",
		"DeleteTemplateExams": "Delete template exams",
		"AreYouSureToDeleteExam": "Are you sure you want to delete selected exam?",
		"AreYouSureToDeleteExams": "Are you you want to delete selected exams?",
		"AreYouSureToDeleteTmpExam": "Are you you want to delete selected template exam?",
		"AreYouSureToDeleteTmpExams": "Are sure you want to delete selected template exams?",
		"YesDelete": "Yes, delete",
		"NoSubmissionsForGroupExam": "No submissions exist for this exam, ending it will move it to Scheduled exams.",
		"NoSubmissionsForIdExam": "No submissions exist for this exam, ending the exam will archive it.",
		"ActiveStudents": "Active students",
		"OfflineStudents": "Offline students",
		"PenAndPaperStudents": "Pen & paper students",
		"AbsentStudents": "Absent students",
		"FilterStudents": "Filter students",
		"Updated": "Updated",
		"UpdatedEvery20Sec": "updates every 20 seconds",
		"StudentInformation": "Student information",
		"LockSettings": "Lock settings",
		"Actions": "Actions",
		"Started": "Started",
		"LatestDataReceived": "Latest data received",
		"TurnedIn": "Handed in",
		"StudentStatus": "Student status",
		"Lockstatus": "Lockstatus",
		"TheClassName": "The class name",
		"Create": "Create",
		"EnterTheClassName": "Enter the class name",
		"TheNameIsNotAllowed": "The name is not allowed.",
		"TheCourseName": "The course name",
		"EnterTheCourseName": "Enter the course name",
		"TheGroupsName": "The groups name",
		"EnterTheGroupsName": "Enter the groups name",
		"TextQuestion": "Text question",
		"SingleChoiceQuestion": "Multiple choice question", // Single choice --> Multiple choice
		"MultiChoiceQuestion": "Multiple response question", // Multiple choice --> Multiple response
		"WordGapQuestion": "Word gap question",
		"LoadDraft": "Load draft",
		"LoadDraftExplanation": "We found a draft with changes to \"{0}\" that was last edited on {1}, do you wish to load the draft?",
		"NoDiscardDraft": "No, discard draft",
		"QuestionCapDescription_Soft": "A soft limit allows the students to exceed the limit, and a warning is shown if it is exceeded.",
		"QuestionCapDescription_Hard": "A hard limit prevents the students from exceeding the limit.",
		"QuestionTitle": "Question title",
		"QuestionShownToTheStudents": "Question shown to the students",
		"QuestionNeedsAValidAnswer": "One of the answering alternatives must be marked as correct.",
		"Alternative": "Alternative",
		"Options": "Options",
		"AddAlternative": "Add alternative",
		"QuestionNeedsAtLeastAValidAnswer": "At least one of the answering alternatives must be marked as correct.",
		"Correct": "Correct",
		"CorrectAnswer": "Correct answer",
		"CorrectAlternative": "Correct alternative",
		"IncorrectAnswer": "Incorrect answer",
		"Scoring": "Scoring",
		"RemoveImage": "Remove image",
		"Remove": common.remove,
		"MoveUp": "Move up",
		"MoveDown": "Move down",
		"Exam": "Exam",
		"EndExam": "End exam",
		"RemoteProctoring": "Remote proctoring",
		"RemoteProctoring.Access": "Open remote proctoring",
		"RemoteProctoring.Info": "This button will open a new tab to the external proctoring dashboard.",
		"DownloadOfflineFile": "Download offline file",
		"NoStudentsStartedTheExam": "No students have started this exam",
		"StudentsHasNotHandedInFinalAnswers": "One or more students have not handed in their final answers.",
		"StudentsAreOfflineAndHasNotHadTheirFinalAnswersUploaded": "One or more students are offline and have not had their final answers uploaded.",
		"StudentsHasNotStartedTheExam": "One or more students have not started the exam.",
		"Done": "Done",
		"EditCourse": "Edit course",
		"LackingPermissions": "Missing permissions",
		"LackingPermissionsToDoThis": "You seem to lack the permissions to do this.",
		"Change": "Change",
		"ArchiveCourse": "Archive course",
		"AreYouSureYouWantToArchiveTheCourse": "Do you want to archive this course?",
		"Archive_Course_YouCanNotUndoThis": "It will move to the archive and you can restore it later.",
		"Upload": common.upload,
		"TheFileIsEmpty": "The file is empty.",
		"CouldNotReadFile": "Could not read the file because of faulty format.",
		"CouldNotRead": "Could not read",
		"TheLine": "the line",
		"TheLines": "the lines",
		"SomethingWentWrong": "Something went wrong.",
		"SomethingWentWrongLong": "An error occurred, please try again later or contact support.",
		"LatestDownload": "Last downloaded",
		"NotSet": "Not set",
		"NotAnswered": "Not answered",
		"NotGraded": "Not graded",
		"Published": "Published",
		"NotPublished": "Not published",
		"Published.plural": "Published",
		"NotPublished.plural": "Not published",
		"NotHandedIn": "Not handed in",
		"HandedIn": "Handed in",
		"NotHandedIn.plural": "Not handed in",
		"HandedIn.plural": "Handed in",
		"CurrentExam": "Current exam",
		"NotYetRated": "Not yet graded",
		"GradesLastSaved": "Grades last saved:",
		"TheStudent": "The student",
		"Student": common.student,
		"StudentX": "Student {0}",
		"StudentsAnswers": "Students' Answers",
		"FinalGrade": "Final result",
		"FinalGradesForX": "Final results for {0}",
		"FinalGradesFor": "Final grades for",
		"ResultsVisibilityWhenPublishing": "The students will be able to see the questions, answers, comments and grades if you publish the results.",
		"ResultsVisibilityWhenUnpublishing": "The students will no longer be able to see the questions, answers, comments and grades if you unpublish the results.",
		"ThereAreStillStudentsWhoAreUnfinished": "There are still students who has yet to turn in their final answers, do you really want to publish the results?",
		"Publish.Ellipsis": "Publish...",
		"Unpublish.Ellipsis": "Unpublish...",
		"PublishResults": "Publish results",
		"UnpublishResults": "Unpublish results",
		"PublishedTheResults": "Published the results",
		"UnpublishedTheResults": "Unpublished the results",
		"FailedToPublishResults": "Failed to publish the results",
		"FailedToUnpublishResults": "Failed to unpublish the results",
		"ResultsForX": "Results for {0}",
		"WordsNoCap": "words, no limit",
		"WordsSoftCap": "words, soft limit",
		"WordsHardCap": "words, hard limit",
		"Grading": "Grading",
		"SearchStudent": "Search student",
		"FinalGradesForXHasNotBeenTurnedIn": "Final answers for {0} has not been turned in, you can't grade this student until that has been done.",
		"UploadOffLineFileToGradeStudent": "Upload an offline file with the students final answers to be able to grade the student.",
		"OfflineFileName": "Offline file should be named: {0}",
		"Answer": "answer",
		"Answer.Capitalized": "Answer",
		"Answer.WordCount": "Word count",
		"XAnswer": "{0} answer",
		"point": "point",
		"points": "points",
		"XPoints": "{0} points",
		"XOfYPoints": "{0} of {1} points",
		"Points": "Points",
		"Total": "Total",
		"Grade": "Grade",
		"Grades": "Grades",
		"Grade.Verb": "Grade",
		"Ability": "Ability",
		"Abilities": "Abilities",
		"StartGrade": "Start grading",
		"ToOverview": "To overview",
		"XOfYQuestionsGraded": "{0} of {1} questions graded",
		"Of": "of",
		"XOfY": "{0} of {1}",
		"AnswerShouldBeAroundXWordsLong": "The answer should be around {0} words long",
		"AnswerMayNotBeLongerThanXWords": "The answer may not be longer than {0} words",
		"OnlyOneAlternativeIsCorrect": "Only one alternative is correct",
		"ManyAlternativesAreCorrect": "One or more alternatives can be correct",
		"PrintExam": "Print exam",
		"Teacher": "Teacher",
		"Scope_make_course": "Create course",
		"Scope_view_course": "View course",
		"Scope_edit_course": "Edit course",
		"Scope_make_exam": "Create exam",
		"Scope_view_exam": "View exam",
		"Scope_edit_exam": "Edit exam",
		"Scope_plan_exam": "Plan exam",
		"Scope_stop_exam": "Stop exam",
		"Scope_copy_exam": "Copy exam",
		"Scope_open_exam": "Open exam",
		"Scope_run_exam": "Run exam",
		"Scope_grade_exam": "Grade exam",
		"Scope_view_exam_grades": "View exam grades",
		"Scope_download_exam": "Download exam",
		"Scope_upload_exam": "Upload exam",
		"Scope_monitor_exam": "Monitor exam",
		"Scope_publish_exam": "Publish exam",
		"Scope_link_class": "Link class",
		"Scope_make_group": "Create group",
		"Scope_link_group": "Link group",
		"Scope_view_group": "View group",
		"Scope_edit_group": "Edit group",
		"Scope_archive_group": "Archive group",
		"Scope_pull_student": "Pull student",
		"Scope_add_student": "Add student",
		"Scope_make_node": "Create node",
		"Scope_apply_role": "Apply role",
		"Scope_make_role": "Create role",
		"StartDate": "Start date",
		"StartTimeLocal": "Start time (local time)",
		"LimitDescription": "Exam can be started max this many minutes after start time",
		"Stop": "Stop",
		"StopDate": "Stop date",
		"StopTime": "Stop time",
		"DurationDescription": "Number of minutes the student has to do the exam",
		"OtherSettings": "Other settings",
		"MaximumScore": "Max points for this exam",
		"AreYouReallySure": "Are you really sure?",
		"Elapsed": "Elapsed",
		"OverallProgress": "Overall progress",
		"Print.PageBreak": "Page Break",
		"Print.BlankPage": "Blank Page",
		"Print": "Print",
		"PrintAttendance": "Print attendance list",
		"PrintPaperExam": "Print exam",
		"Print.Ellipsis": "Print or download...",
		"DownloadPDF.One": "Download PDF as one file",
		"DownloadPDF.Multiple": "Download PDF as multiple files",
		"PrintResults": "Print results",
		"PrintResults.Feedback.Error.NoStudentSelected": "You must select at least one student whose answers will be printed.",
		"PrintResults.Feedback.Error.NoQuestionSelected": "You must select at least one question to print.",
		"PrintCloud.Button": "Cloud Print",
		"PrintCloud.Header": " Digiexam Cloud Print",
		"PrintCloud.Body": "You are about to print with Digiexam Cloud print. The emails will be sent to {0} within 20 minutes.",
		"PrintCloud.FileSelect": "Download as multiple files or as a single file",
		"PrintCloud.FileSelect.SingleFile": "Single File",
		"PrintCloud.FileSelect.MultipleFiles": "Multiple Files",
		"Share": "Share",
		"ShareGradingWork": "Share grading work",
		"ShareGradingWork.Ellipsis": "Share grading work...",
		"ShareGradingWork.Remove": "Remove grading share",
		"ThisUserIsDeleted": "Deleted user",
		"XOfYFinalResultsSet": "{0} of {1} final results set",
		"Loading": "Loading",
		"LoadingExam": "Loading exam",
		"ContinueGrading": "Continue grading",
		"HideGradedStudents": "Hide graded students",
		"ShowGradedStudents": "Show graded students",
		"NextStudent": "Next student",
		"PreviousStudent": "Previous student",
		"CantEditGradeBecausePublished": "You can't edit the result of a student when the exam is published. Please unpublish exam first.",
		"XHasNotAnsweredThisQuestion": "{0} has not answered this question.",
		"StudentHasNoFinalGrade": "Not graded",
		"XHasLeftExamBlankYouCantAnswer": "{0} has left the exam blank, you can not set a grade on a blank exam.",
		"TypeToSearch": "Type in the field above to search...",
		"NoStudentsFound": "No students found.",
		"RemoveTheActiveFiltersToShowHiddenStudents": "Remove the active filters to show hidden students.",
		"RemoveFilters": "Remove filters",
		"All": "All",
		"Online": "Online",
		"PenAndPaper": "Pen & paper",
		"Offline": "Offline",
		"Absent": "Absent",
		"Active": "Active",
		"YesStartExam": "Yes, start the exam",
		"DoYouWantToStartTheExam": "Do you want to start the exam {0}",
		"ExamId": "Exam ID",
		"Ongoing": "Ongoing",
		"NotStarted": "Not started",
		"MoveExam": "Move exam",
		"ErrorLoadingCourses": "There was an error loading the courses",
		"FaultMovingExamTryAgainLater": "An error occured when moving the exam, please try again later or contact support.",
		"ChooseWhichClassToMoveExam": "Choose which class you want to move the exam to.",
		"YouNeedToSetATitle": "You need to set a title.",
		"ThereIsAlreadyARubricWithThatTitle": "There is already a rubric with that title.",
		"YouNeedToSetASubject": "You need to set a subject.",
		"YouNeedToAddQuestions": "You need to add questions.",
		"AQuestionNeedsATitle": "A question needs a title.",
		"AQuestionNeedsText": "A question needs text.",
		"AMOrSQuestionNeedsAlternatives": "A multichoice or singlechoice question needs alternatives.",
		"AQuestionAlternativeNeedsATitle": "A question alternative needs a title.",
		"AMOrSQuestionNeedsCorrectAlternative": "A multichoice or singlechoice question needs a correct alternative.",
		"AQuestionHasAnInvalidCap": "A question has an invalid word limit.",
		"AQuestionNeedsAMaxScore": "A question needs a max score.",
		"Search": "Search",
		"QuestionNotGraded": "The question is not graded.",
		"TeachersComment": "Teachers comment",
		"ObtainedScore": "Score obtained",
		"TextOnlyQuestion": "Heading",
		"TextOnlyAboutPlaceholder": "Heading description (optional)",
		"Abbreviation": "Abbreviation",
		"UpdateInformation": "Update information",
		"ChangeCover": "Change cover",
		"ChangeProfilePhotoOrCover": "Images for the organization",
		"Incorrect": "Incorrect",
		"NotUploaded": "Not uploaded",
		"Uploaded": "Uploaded",
		"Uploading": "Uploading",
		"UploadFailed": "Upload failed",
		"DoYouWantToShareX": "Do you want to share '%v'?",
		"EnterTheEmailAdressYouWantToShareWith": "Enter the e-mail address of the person you want to share '%v' with.",
		"ExampleEmail": "example@example.com",
		"Organization": "Organization",
		"Organization.Edit": "Edit {0}",
		"AllOrganizations": "All organizations",
		"AllOrganizationTypes": "All organization types",
		"UnspecifiedQualityStatus": "Unspecified quality status",
		"Created": "Created",
		"Freemium": "Freemium",
		"NonFreemium": "Non-freemium",
		"FeatureRemoteProctoringEnabled": "Feature: Remote Proctoring",
		"LoggingYouIn": "Logging you in",
		"LoggingIn": "Logging in",
		"Statistics": "Statistics",
		"Roles": "Roles",
		"RolesAndUsers": "Roles & users",
		"Permissions": "Permissions",
		"NumberOfUsers": "Number of users",
		"NoRolesAddedAddRole": "No roles added. Add a role.",
		"AddRole": "Add role",
		"PendingInvites": "Pending invites",
		"NoPendingInvites": "No pending invites.",
		"InviteUsers": "Invite users",
		"Revoke": "Revoke",
		"ALinkWillBeSentToThisUserInvite": "A link will be sent to these users where they can accept the invite. If they accept they can choose to use an existing account or create a new one.",
		"Role": "Role",
		"ToInvite": "Invite",
		"TheRoleXHasBeenCreated": "The role '{0}' has been created.",
		"TheRoleXHasBeenDeleted": "The role '{0}' has been removed.",
		"TheNodeYouTriedToVisitDoesntExist": "The organization you tried to visit doesn't exist.",
		"Teachers": "Teachers",
		"Exams": common.exams,
		"ExamTemplates": common.examTemplates,
		"TheInviteToXHasBeenSent": "The invite to '{0}' has been sent.",
		"TheInvitesToXPeopleBeenSent": "The invites to {0} people has been sent.",
		"FailedToSendInvite": "Failed to send invite: {0}",
		"FailedToSendInvites": "Failed to send invites: {0}",
		"YouNowHaveTheRoleOfXAtX": "You now have the role of {0} at {1}.",
		"InvalidInviteError": "The invitation you tried to access isn't valid.",
		"InvalidActivationLinkError": "The activation link you tried to use is invalid.",
		"Resend": "Resend",
		"UsersWithRole": "Users with role",
		"ChangeProfileImage": "Change profile image",
		"UploadImage.FailedX": "Failed to upload image: {0}",
		"EditInformation": "Edit information",
		"DoYouWantToRemoveTheRole": "Do you want to remove the role?",
		"DoYouWantToRemoveTheRoleX": "Do you want to remove the role {0}",
		"DoYouWantToRevokeTheRole": "Do you want to revoke the role?",
		"DoYouWantToRevokeTheRoleForX": "Do you want to revoke the role for {0}?",
		"RevokedRoleXFromX": "Revoked role {0} from {1}.",
		"CouldNotRevokeRoleXFromX": "Could not revoke role {0} from {1}.",
		"RoleIsExternallyManaged": "The role is externally managed and will only be revoked in Digiexam and not in the master system.",
		"ResentTheInviteToX": "Resent the invite to {0}.",
		"CouldNotResendTheInviteToX": "Could not resend the invite to {0}.",
		"DoYouWantToRemoveTheInvite": "Do you want to remove the invite?",
		"DoYouWantToRemoveTheInviteToX": "Do you want to remove the invite for {0}?",
		"RemovedTheInviteToX": "Removed the invite to {0}.",
		"CouldNotRemoveTheInviteToX": "Could not remove the invite to {0}.",
		"TheOrganizationXHasBeenCreated": "The organization {0} has been created.",
		"Organizations": "Organizations",
		"CreateOrganization": "Create organization",
		"ParentOrganizationId": "Parent organization ID",
		"CouldNotCreateTheOrganizationX": "Could not create the organization {0}.",
		"CouldNotRemoveExamX": "Could not remove the exam \"{0}\".",
		"RemovedExamX": "Removed the exam \"{0}\".",
		"AnonymizeExam": "Anonymize exam",
		"AnonymizeExam.Ellipsis": "Anonymize exam...",
		"DeAnonymize": "Remove anonymization",
		"DeAnonymize.Ellipsis": "Remove anonymization...",
		"AnonymizeExplanation": "Changing the exam to be anonymous will hide the students’ names and other information for anyone grading, printing the exam or downloading its grades spreadsheet.",
		"DeAnonymizeExplanation": "If you remove the anonymization of the exam, students’ names and information will be visible to anyone grading or printing the exam, or downloading the grades spreadsheet.",
		"RoleType_0": "PUB",
		"RoleType_1": common.student,
		"RoleType_2": "Teacher",
		"RoleType_4": "Administrator",
		"RoleType_8": "Master",
		"RoleType_16": "Account Manager",
		"RoleType_32": "Invigilator",
		"ShareTheResults": "Share the results",
		"YouSharedXWithY": "You shared \"{0}\" with {1}",
		"CouldNotShareCantHandleExams": "Could not share exam because this user can't handle exams.",
		"CouldNotShareCantHandleRubrics": "Could not share rubric because this user can't handle rubrics.",
		"CouldNotShareExamNoEmailX": "Could not share exam because there is no user with email \"{0}\"",
		"CouldNotShareExamCantGrade": "Could not share exam because \"{0}\" can't grade exams",
		"CouldNotShareGradingOwner": "Could not share grading work because \"{0}\" is the owner of this exam",
		"FailedToShareExam": "Failed to share exam",
		"FailedToShareRubric": "Failed to share rubric",
		"NameOrStudentCode": "Name or student code",
		"Previous": "Previous",
		"Next": "Next",
		"NoExamsFound": "No exams found",
		"ShowQuestionDetails": "Show the question details",
		"HideQuestionDetails": "Hide the question details",
		"Images": "Images",
		"Image": "Image",
		"ColorRed": "Red",
		"ColorBlue": "Blue",
		"ColorAqua": "Aqua",
		"ColorPink": "Pink",
		"ColorGreen": "Green",
		"ColorYellow": "Yellow",
		"Color": "Color",
		"Comment": "Comment",
		"AnnotationSummary": "Annotation summary",
		"TeachersAnnotations": "Teachers annotations",
		"TeachersAnnotations.Tooltip.Text": "Background graphics is used in the printing settings to display the annotation highlight colors.",
		"Delete": "Delete",
		"Deleted": "Deleted",
		"OnePerLine": "One per line",
		"UserIsDisabled": "User is disabled",
		"ContactDigiExamForMoreInformation": "Contact Digiexam for more information.",
		"ServerRespondedWith": "Server responded with: {0}",
		"ShowMore": "Show more",
		"ShowLess": "Show less",
		"MustBeANumber": "Must be a number",
		"CantBeHigherThanX": "Can't be higher than {0}",
		"CantBeLowerThanX": "Can't be lower than {0}",
		"Rubric": "Rubric",
		"Rubrics": common.rubrics,
		"RemoveGrade": "Remove grade",
		"RemoveAbility": "Remove ability",
		"WarningWhenRemovingRubricGrade": "Removing this grade will also remove all criteria associated with the grade.",
		"WarningWhenRemovingRubricAbility": "Removing this ability will also remove all criteria associated with the ability.",
		"AddGrade": "Add grade",
		"AddAbility": "Add ability",
		"ClickToEdit": "Click to edit",
		"Criteria": "Criteria",
		"Criterion": "Criterion",
		"Description": "Description",
		"AssessmentType": "Assessment type",
		"ScoreBasedGrading": "Score based grading",
		"ScoreBasedGrading.Description": "The exam is score based.",
		"ScoreBasedGrading.Info1": "Set points for each question and set a final grade for their exam. Multiple choice and multiple response questions are automatically graded for you.",
		"RubricBasedAssessment": "Rubric based assessment",
		"RubricBasedAssessment.Description": "The exam is assessed based on a rubric.	",
		"RubricBasedAssessment.Info1": "Use a rubric for a more detailed way of evaluating how students perform within different skills or criteria.",
		"DropARubricHereToUseItInTheExam": "Drop a rubric here to use it in the exam.",
		"View": "View",
		"RubricRequiredToSelectQuestionAbilities": "You need to add a rubric to the exam before you can select abilities for this question.",
		"AbilitiesToMeasure": "Abilities to measure",
		"AnsweringAlternatives": "Answering alternatives",
		"RemovingRubricFromExamWarning": "Some questions in the exam are configured with abilities to measure. If you remove the rubric that configuration will also be removed. Are you sure you want to remove the rubric \"{0}\"?",
		"GradeNameIsRequired": "Grade name is required",
		"AbilityNameIsRequired": "Ability name is required",
		"NamelessGrade": "Nameless grade",
		"YouNeedToAddGrades": "You need to add grades",
		"YouNeedToAddAbilities": "You need to add abilities",
		"ResultSummary": "Result summary",
		"SummarizedAssessment": "Summarized assessment",
		"ShowRubric": "Show rubric",
		"PublishedResults": "Published results",
		"TheResultsArePublished": "The results are published",
		"ShowWhichPartsCanBeSeenByTheStudents": "Show which parts can be seen by the students",
		"StudentsResults": "Students' results",
		"ShowIfAlternativeIsCorrect": "Show if alternative is correct",
		"Score": "Score",
		"RightToLeft.Long": "Text direction: Right-to-left",
		"RightToLeft.Long.Info1": "Enable this setting for writing systems that are right-to-left, e.g. Persian, Arabic and Hebrew.",
		"LockedQuestionSequence.Title": "Locked question sequence (MEQ)",
		"LockedQuestionSequence.Disclaimer": "The question titles will still be visible.",
		"LockedQuestionSequence.Info": "The sequence of the questions is locked in the exam. A student cannot go back to an answered question to edit their answer.",
		"FindStudents": "Find students",
		"StudentName": "Student name",
		"StudentSearch.Placeholder": "Name, Student Code or Email",
		"StudentSearch.Placeholder.CodeDisabled": "Name or Email",
		"StudentSearch.TooManyResults": "Try a longer search term to narrow down the results",
		"StudentSearch.FilterTooltip": "You can filter results based on which accessibility settings are enabled for the student. Move the mouse to \"Accessibility settings\" and select which settings to filter by.",
		"StudentSearch.ShowAll": "Show all",
		"StudentSearch.ShowAllByEmailCode": "Show all (with email address as student code)",
		"StudentSearch.Unauthorized": "Freemium schools are not allowed to manage students. Contact sales to upgrade your school.",
		"StudentSearchUnavailable": "Can't search for students at the moment, please try again or contact Digiexam support.",
		"AccountCreated": "Account created",
		"StudentAt": "Student at",
		"NoClassesFound": "No classes found",
		"ViewResult": "View result",
		"ViewClass": "View class",
		"StudentHasNotParticipatedInAnyExams": "The student has not participated in any exams that you have access to.",
		"StudentDoesNotBelongToAnyClass": "The student does not belong to any class that you have access to.",
		"StudentNotFound": "Could not find student with id {0}",
		"Exam.OnlyYourExamsShown": "Only your exams are shown.",
		"Class.OnlyYourClassesShown": "Only your classes are shown.",
		"RubricUsedInExam": "This rubric has been used in an exam. Grades and abilities can no longer be changed.",
		"SaveAsNewCopyRubric": "Choose SAVE AS NEW to create a new copy of this rubric.",
		"SetANewTitle": "Set a new title.",
		"Fullscreen": "Fullscreen",
		"ExitFullscreen": "Exit fullscreen",
		"SalesCRMId": "Pipedrive ID",
		"Search.ShowingXofYMatches": "Showing {0} of {1} matches",
		"TeachersFeedback": "Teacher's feedback",
		"TeachersFeedback.Long": "Teacher's feedback to the student",
		"TeachersFinalFeedback.Long": "Teacher's final feedback to the student",
		"Publish.Publish.LongTitle": "Publish the results so the students can see them",
		"Publish.Publish.PartDescription": "Select the parts that should be visible to the students.",
		"Publish.Published.LongTitle": "Published results seen by the students",
		"Publish.Published.PartDescription.ExamOwnerOrAdmin": "The selected parts are visible to the students, you can change which parts the students can see.",
		"Publish.Published.PartDescription.NotExamOwnerOrAdmin": "The selected parts are visible to the students. Only the exam owner can change which parts the students can see.",
		"Publish.Unpublish.LongTitle": "Unpublish the results seen by the students",
		"Publish.Unpublish.PartDescription": "The selected parts are visible to the students.",
		"Publish.StudentDescription": "The students can only see their own answers.",
		"ShareGrading.LongTitle": "Share the grading work with another teacher",
		"ShareGrading.Description": "Select which questions and students you want to allow the teacher to grade.",
		"ShareGrading.EmailLabel": "Email of the teacher to share with",
		"ShareGrading.Error.EmailMissing": "You must enter the email address of the teacher you want to share the grading work with.",
		"ShareGrading.Error.NoQuestionsSelected": "You must select at least one questions to share.",
		"ShareGrading.Error.NoStudentSelected": "You must select at least one student to share.",
		"Student.StudentCode.Notification.AlreadyAdded.Class": "Student code already in class",
		"Student.StudentCode.Error.MinLength": "Student code is required to be at least 1 characters",
		"Student.StudentCode.Error.MaxLength": "Student code is not allowed to exceed 50 characters",
		"Student.StudentCode.Error.Chars": "Student code is only allowed to contain a-Z 0-9 - . @ _",
		"Student.Name.Error.MinLength": "Name is required to be at least 2 characters",
		"Student.Name.Error.MaxLength": "Name is required to be max 500 characters",
		"Student.New": "New Student",
		"Student.ChangeStudentCode.Title": "Change Student Codes",
		"Student.ChangeStudentCode.Description": "This tool is used to bulk change student codes.",
		"Student.ChangeStudentCode.Excel": "Paste from excel in format: email, student code",
		"Student.ChangeStudentCode.WontApply": "Student Code changes that will not be applied",
		"Student.ChangeStudentCode.WillApply": "Student Code changes to apply",
		"Student.ChangeStudentCode.Verify": "Verify change codes",
		"Student.ChangeStudentCode.Perform": "Perform change codes",
		"Student.ChangeStudentCode.TooManySelected": "Can't change code for more than {0} students at once",
		"Student.ChangeStudentCode.Success.Single": "Student codes were successfully changed",
		"Student.ChangeStudentCode.Success": "{0} student codes were successfully changed",
		"Student.ChangeStudentCode.Progress": "Changing codes for {0} students",
		"Student.ChangeStudentCode.Failure": "The following students could not be changed:",
		"Student.Delete": "Delete Students",
		"Student.Notification.AlreadyAdded.Class": "{0} already in the class",
		"Student.Notification.Error": "An error occurred, {0} could not be added",
		"Student.Notification.DoesNotExist.Single": "No student with the email {0} exists on the organization",
		"Student.Notification.DoesNotExist.Multiple": "Student does not exist on the organization",
		"Student.Notification.NotAdded": "Student not added",
		"Student.Delete.Progress": "Deleting {0} students",
		"Student.Delete.Explanation": "Only students who have not yet started and is not connected to an exam can be deleted.",
		"Student.Delete.Others": "and {0} others...",
		"Student.Delete.Success.Single": "Student was successfully deleted",
		"Student.Delete.Success": "{0} students were successfully deleted",
		"Student.Delete.Failure": "The following students could not be deleted:",
		"Student.Delete.Button": "Delete {0} students",
		"Student.Delete.Button.Single": "Delete {0} student",
		"Student.Delete.TooManySelected": "Can't delete more than {0} students at once",
		"Feedback.Saving.Ellipsis": "Saving...",
		"Feedback.Saved": "Saved",
		"Feedback.Saved.1:Time": "Saved {0}",
		"Feedback.AutoSaved.1:Time": "Automatically saved {0}",
		"Feedback.DraftSaved": "Draft saved",
		"Feedback.DraftSaved.1:Time": "Draft saved {0}",
		"Feedback.ErrorSaving": "Failed to save",
		"Feedback.FailedToShareExam": "Failed to share exam",
		"Feedback.CouldNotRemoveShare": "Could not remove share",
		"Feedback.Added.Entity": "{0} has been added to the class",
		"Feedback.Added.Single.Student": "Added 1 student",
		"Feedback.Added.Count.Students": "Added {0} students",
		"Feedback.ErrorArchiving": "Archiving failed",
		"Feedback.ErrorDeleting": "Deleting failed",
		"Feedback.SuccessArchived": "Archived successfully!",
		"Feedback.SuccessDeleted": "Deleted successfully!",
		"Entity.Created.By": "by {0}",
		"Shared.By": "Shared by {0}",
		"Exam.State.0": "Empty",
		"Exam.State.1": "Draft",
		"Exam.State.2": "Handed in",
		"Exam.State.3": "Blank",
		"Exam.Parts": "Parts",
		"Action.Continue": "Continue",
		"Action.Restore": "Restore",
		"Action.Delete": "Delete",
		"Action.DeleteSelected": "Delete selected",
		"Action.SelectAll": "Select all",
		"Action.DeselectAll": "Deselect all",
		"Action.AddStudent": "Add student",
		"Action.AddStudentToClass": "Add student to class",
		"Action.AddStudentWithEmail": "Add student by e-mail",
		"Action.AddStudent.Plural": "Add multiple students",
		"Action.SelectRubric": "Select rubric",
		"Action.CannotBeUndone": "This action cannot be undone",
		"State.Deleted": "Deleted",
		"State.Archived": "Archived",
		"State.TeachersFeedback.Missing": "The teacher has not written any feedback",
		"State.FinalGrade.Missing": "The teacher has not set a final result",
		"ForgotPassword.Fail.EmailNotFound": "No account found with that email address.",
		"ForgotPassword.Fail.InvalidToken": "There was an error with the link",
		"ForgotPassword.Fail.ExpiredToken": "This link has expired",
		"ForgotPassword.Fail.LinkUsed": "This link has already been used",
		"ForgotPassword.Fail.SendNewLink": "Please press the button to send a new link.",
		"ForgotPassword.Fail.SendNewLinkButton": "Send new link",
		"AcceptInvite.RoleDescription": "You have been invited as {0} at {1}.",
		"AcceptInvite.HowToAccept.Part1": "Create an account to accept your invitation.",
		"AcceptInvite.HowToAccept.Part2": " if you already have a Digiexam account.",
		"AcceptInvite.AcceptDescription": "Accept the role as {0} at {1}.",
		"AcceptInvite.InvalidInvite": "We could not open your invitation. Please try again or contact the person who sent it to you.",
		"PasteFrom.InvalidEmail": "E-mail on line {0} is not valid: {1}",
		"PasteFrom.Duplicate": "The email on line {0} is a duplicate: {1}, only one instance of an email is allowed in the list.",
		"PasteFrom.DoesNotExist": "Could not add students to class, one or more students does not exists on the organization",
		"PasteFrom.InvalidColumnCount.SingularExpected": "Line {0} should have {1} column, but it has {2}: {3}",
		"PasteFrom.InvalidColumnCount.PluralExpected": "Line {0} should have {1} columns, but it has {2}: {3}",
		"PasteFrom.SomethingWentWrong": "An error occurred, please try again later or contact support.",
		"AddStudentsToClass": "Add students to class",
		"PasteFromSpreadsheet.Title": "Paste from spreadsheet",
		"PasteFromSpreadsheet.Description": "You can add multiple students to the class by copy and paste from spreadsheet.",
		"PasteFromSpreadsheet.FormatDescription": "The spreadsheet must contain one column with the students email",
		"PasteFromSpreadsheet.ForMoreInformation": "For more instructions, see the following help article:",
		"PasteFromSpreadsheet.HelpLink.Title": "Adding students to class",
		"PasteFromSpreadsheet.HelpLink.Url": "https://digiexam.zendesk.com/hc/en-us/articles/202559711-Add-students-to-class-by-pasting-from-Excel",
		"GettingStartedGuide.DoNotShowAgain": "Don't show this guide again",
		"GettingStartedGuide.CreateYourExam": "Create your first exam",
		"GettingStartedGuide.slide1.Heading": "Welcome",
		"MonitorExamInfo.Title": "Seamless Grading & Monitoring",
		"MonitorExamInfo.Text1": "Track student progress more easily",
		"MonitorExamInfo.Text2": "Quickly return to the exam view from grading",
		"GettingStartedGuide.slide1.Text1": "Let us introduce you to the Digiexam platform in a few simple steps",
		"GettingStartedGuide.slide1.Text2": "Let's begin",
		"GettingStartedGuide.slide2.Heading": "Create exam",
		"GettingStartedGuide.slide2.Text1": "To create an exam you need a title, subject and at least one question. When you create an exam you can easily set it up as you like. Some of the options include:",
		"GettingStartedGuide.slide2.Item1": "Score Based Grading or Rubric Based Assessment",
		"GettingStartedGuide.slide2.Item2": "Allowing students to use spell check",
		"GettingStartedGuide.slide2.Item3": "Making exams anonymous",
		"GettingStartedGuide.slide3.Heading": "Start or schedule",
		"GettingStartedGuide.slide3.Text1": "You can start an exam immediately or schedule it for later.",
		"GettingStartedGuide.slide4.Heading": "Exam ID or Group",
		"GettingStartedGuide.slide4.Text1": "You have two options for giving students access to the exam:",
		"GettingStartedGuide.slide4.Text2": "Exam ID",
		"GettingStartedGuide.slide4.Text3": "Group",
		"GettingStartedGuide.slide4.Item1": "A unique Exam ID is generated when starting an exam",
		"GettingStartedGuide.slide4.Item2": "Any student can start the exam with the Exam ID",
		"GettingStartedGuide.slide4.Item3": "No need to add students in advance",
		"GettingStartedGuide.slide4.Item4": "Only students in the selected list can take the exam",
		"GettingStartedGuide.slide4.Item5": "Copy and paste student lists from Excel",
		"GettingStartedGuide.slide4.Item6": "Exam will automatically be available for the students in the list",
		"GettingStartedGuide.slide5.Heading": "Write exam",
		"GettingStartedGuide.slide5.Text1": "Now it’s time for your students to write the exam! First they need to download the Digiexam app to their Windows, Mac, Chromebook or iPad device.",
		"GettingStartedGuide.slide5.Text2": "Students access the exam by the Exam ID (open exams) or by using the same student details as were added to the class (planned exams).",
		"GettingStartedGuide.slide5.tip": "When students start the exam the Digiexam app locks their screen so they can’t do anything else while taking the exam.",
		"GettingStartedGuide.slide6.Heading": "Grade exam",
		"GettingStartedGuide.slide6.Text1": "You can give students detailed feedback on their answers. It’s super easy to comment on and highlight specific parts of the student's answer.",
		"GettingStartedGuide.slide6.Item1": "Grade the exam per question or per student",
		"GettingStartedGuide.slide6.Item2": "Automatic grading for score based multiple choice questions",
		"GettingStartedGuide.slide6.Item3": "No more unreadable hand writing",
		"GettingStartedGuide.slide6.tip": "You can share the grading with your co-workers. Collaborating has never been easier!",
		"GettingStartedGuide.slide7.Heading": "Publish exam",
		"GettingStartedGuide.slide7.Text1": "When you are finished with grading the exam you can publish the results so that your students can log in and see their results.",
		"GettingStartedGuide.slide7.Text2": "You can choose which parts of the exam to publish. For example you can choose to publish results but not questions and answers until all students have taken the exam.",
		"GettingStartedGuide.slide7.tip": "You can publish and unpublish exam results whenever you want.",
		"NodeType.Title": "Organization type",
		"NodeType.0": "Not specified",
		"NodeType.1": "Internal",
		"NodeType.2": "Higher education",
		"NodeType.3": "Secondary education",
		"NodeType.4": "Primary education",
		"NodeType.5": "Education company",
		"QualityStatus.Title": "Quality status",
		"QualityStatus.0": "Not verified",
		"QualityStatus.1": "Verified",
		"QualityStatus.2": "Junk",
		"AbilityOverview.Title": "Abilities",
		"AbilityOverview.Description": "Select a rubric to see how the student has performed in the abilities it measures.",
		"AbilityOverview.NoItems": "To see the performance in individual abilities the student must have written at least one exam that is graded using a rubric.",
		"Student.None": "No students",
		"Student.Singular": common.student,
		"Student.Plural": common.students,
		"SyncToLMS.Title": "Learning Management System (LMS)",
		"SyncToLMS.Published": "Send your students' published grades and feedback to your LMS.",
		"Notifications.Title": "Notifications",
		"Notifications.Published": "Notify students by email that exam results have been published.",
		"ExamStarts": "Exam starts",
		"ExamEnded": "Exam ended",
		"Month.1": "January",
		"Month.2": "February",
		"Month.3": "March",
		"Month.4": "April",
		"Month.5": "May",
		"Month.6": "June",
		"Month.7": "July",
		"Month.8": "August",
		"Month.9": "September",
		"Month.10": "October",
		"Month.11": "November",
		"Month.12": "December",
		"YourComputerLocalTime": "Your computer's local time is",
		"MoreOnHowYouUploadAnswerFiles": "More on how you upload offline answer files",
		"Accessibility": "Accessibility",
		"AccessibilitySettings": "Accessibility settings",
		"AllowSpellcheckForStudent": "Allow spell check for this student",
		"City": "City",
		"State": "State",
		"Country": "Country",
		"YouHaveNotAddedRubricToExam.Saving": "You have no rubric attached to this exam.",
		"AbilitiesHaveNotBeenSelectedForAllQuestions.Saving": "Abilities to measure have not been selected for all questions.",
		"MergeSelectedOrganizations": "Merge selected organizations",
		"MergeSelectedOrganizations.Description": "This tool is used to merge organizations.",
		"MergeSelectedOrganizations.SelectedOrganizations": "Selected organizations to merge:",
		"MergeSelectedOrganizations.MergeTo": "Select target organization to merge to:",
		"MergeSelectedOrganizations.Errors": "Can not merge due to the following errors:",
		"MergeSelectedOrganizations.OrgIdErrors": "Organization is a paying customer:",
		"MergeSelectedOrganizations.mergeCheck.button": "Merge check",
		"MergeSelectedOrganizations.mergePossible.status": "Organization merge is possible.",
		"MergeSelectedOrganizations.mergePayingPossible.status": "Organization merge is possible. But the target is a paying customer.",
		"MergeSelectedOrganizations.mergePossible.button": "Merge",
		"MergeSelectedOrganizations.mergeDone.status": "Organization merge started. You will be notified via email when the organizations have been merged.",
		"OrgId": "Organization ID",
		"ResetLTICredentials": "Reset LTI credentials",
		"EnableLTIIntegration": "Enable LTI integration",
		"DisableLTIIntegration": "Disable LTI integration",
		"Integrations": "Integrations",
		"LTIIntegration": "LTI integration",
		"LTIIntegration.MoreInfo": "Read more about LTI integration",

		"Jobs": "Jobs",
		"Jobs.Id": "Job ID",
		"Jobs.Details": "Job Details",
		"Jobs.StartedBy": "Started By: ",
		"Jobs.Successful": "Successful: ",
		"Jobs.Skipped": "Skipped: ",
		"Jobs.StudentImport": "Student Import",
		"Jobs.Status.Created": "Created",
		"Jobs.Status.Running": "Running",
		"Jobs.Status.Done": "Done",
		"Jobs.Status.Error": "error: incorrect status",
		"Jobs.ClearSearch": "Clear search",
		"AccountManagerImports": "Imports",
		"AccountManagerImports.Title": "Import Details",
		"AccountManagerImports.Id": "Import ID",
		"AccountManagerImports.NotFound": "No imports found",
		"AccountManagerImports.ImportStudents": "Import Students",
		"AccountManagerImports.ImportingStudents": "Loading imports..",
		"AccountManagerImports.ImportCounter": "{0} of {1} students imported",
		"AccountManagerImports.Imported": "Imported:",
		"AccountManagerImports.ImportedStudents": "Imported Students: ",
		"AccountManagerImports.DeletedStudents": "Student with ID {0} has been deleted",
		"AccountManagerImports.DeletedStudents.Internal": "Student with ID {0} has been deleted by Digiexam staff",
		"AccountManagerImports.AccessibilitySettings": "Accessibility Settings",
		"AccountManagerImports.Errors": "Errors: ",
		"AccountManagerImports.UnableToImport": "Unable to import({0})",
		"AccountManagerImports.SuccessfullyImported": "Imported student data({0})",
		"AccountManagerImports.LoadError": "Could not load import information",
		"AccountManagerImports.LoadError.Student": "Could not load import information about student {0}",
		"AccountManagerImports.Duplicate.Title": "Student already exists on {0}",
		"AccountManagerImports.Duplicate.Message": "The user {0} already have a student on {1}.",
		"AccountManagerImports.Duplicate.LoadError": "Could not load import errors",
		"AccountManagerImports.Placeholder.PasteStudents": "Paste the student data here",
		"AccountManagerImports.SelectOrganizationInfo": "Please select an organization",
		"AccountManagerImports.UserId": "User ID",
		"AccountManagerImports.Status": "Status",
		"AccountManagerImports.Created": "Created",
		"AccountManagerImports.Option.Any": "Any",
		"AccountManagerImports.Error.SomethingWentWrong": "An error occurred, please try again later or contact support.",

		"Node.Setting.StudentCode": "Use student codes",
		"Node.Setting.StudentCode.MoreInfo": "Student codes are optional and can be disabled if not needed. If student codes are disabled, they won't appear in Digiexam and won't be required when creating students.",

		"Integrations.SAML": "SAML integration",
		"Integrations.SAML.Enable": "Enable SAML integration",
		"Integrations.SAML.Disable": "Disable SAML integration",
		"Integrations.SAML.Skolfederation": "Skolfederation",
		"Integrations.SAML.Other": common.other,
		"Ingegrations.SAML.Upload": common.upload,
		"Integrations.SAML.Save": common.save,
		"Integrations.SAML.Remove": "Remove Identity Provider",
		"Integrations.SAML.UnitId": "Unit Code",
		"Integrations.SAML.FileUpload.1": "Upload an Identity Provider (IDP) metadata XML file.",
		"Integrations.SAML.FileUpload.2": "Drop the file anywhere on the page or click this box.",
		"Integrations.SAML.SkolfederationSelect": "Skolfederation Identity Provider (IDP)",
		"Integrations.SAML.ValidUntil": "Valid until",
		"Integrations.SAML.Error.403": "An error occured: Missing permission.",
		"Integrations.SAML.IDPAlreadyInUse": "An IDP with this entity id is already in use by another organization.",
		"Integrations.SAML.Error.Unhandled": "An unknown error occurred.",
		"Integrations.SAML.MoreInfo": "Read more about SAML integration",

		"Integrations.Skolon": "Skolon integration",
		"Integrations.Skolon.Enable": "Enable Skolon integration",
		"Integrations.Skolon.Disable": "Disable Skolon integration",
		"Ingegrations.Skolon.Save": common.save,
		"Integrations.Skolon.SkolonId": "Skolon ID",
		"Integrations.Skolon.WrongRegExp": "A Skolon ID can only contain alphanumeric characters",
		"Integrations.Skolon.TooShort": "A Skolon ID must be contain 50 characters",
		"Integrations.Skolon.SaveSuccess": "Successfully saved the Skolon ID",
		"Integrations.Skolon.SaveError": "Error during the Skolon ID save",
		"Integrations.Skolon.SaveConflict": "Skolon ID is already in use by another organization",
		"Integrations.Skolon.MoreInfo": "Read more about Skolon integration",

		"ExternalTools": "External tools",
		"ExternalTools.New": "New external tool",
		"ExternalTools.Create": "Create external tool",
		"ExternalTools.TitleAdd": "Add external tool",
		"ExternalTools.MyTool": "My tool",
		"ExternalTools.Existing": "Existing external tools",
		"ExternalTools.Edit": "Edit external tool",
		"ExternalTools.Delete": "Delete external tool",
		"ExternalTools.LandingPage": "Landing page",
		"ExternalTools.LandingPageURL": "Landing page URL",
		"ExternalTools.WholeDomain": "Whole domain",
		"ExternalTools.SingleWebPage": "Single web page",
		"ExternalTools.PartOfDomain": "Part of domain",
		"ExternalTools.AllowLists": "Allowlists",
		"ExternalTools.AllowDomains": "Allow whole domains",
		"ExternalTools.AllowSinglePages": "Allow single web pages",
		"ExternalTools.AllowPartialDomainAccess": "Allow partial access to domains",
		"ExternalTools.AddURL": "Add URL",
		"ExternalTools.InvalidURL": "Entered web address is not valid",
		"ExternalTools.InvalidURLFormat": "Entered web address does not have a valid format",
		"ExternalTools.URLCouldNotBeReached": "Entered web address could not be reached",
		"ExternalTools.URLAlreadyExists": "Entered web address is already in the list",
		"ExternalTools.InvalidLandingPage": "The landing page is not valid",
		"ExternalTools.InvalidLandingPageFormat": "The landing page does not have a valid format",
		"ExternalTools.LandingPageCouldNotBeReached": "The landing page could not be reached",
		"ExternalTools.StudentEquipmentChecks": "Student equipment checks",
		"ExternalTools.Camera": "Camera",
		"ExternalTools.Microphone": "Microphone",
		"ExternalTools.ScreenShare": "Screen share",
		"ExternalTools.CanEditEquipment": "Teacher can set/edit student equipment",
		"ExternalTools.CanEditLandingPage": "Teacher can set/edit landing page",
		"ExternalTools.ChangeIcon": "Change icon",
		"ExternalTools.Tooltip.New": "External tools is a feature that makes it possible to use variety of web applications and web sites in exams that cannot be used with the online resources feature." +
			" For example, the feature supports web sites or web applications that requires the user to login.",
		"ExternalTools.Tooltip.Name": "The name of the external tool that will be shown to the student in the Digiexam client when taking the exam.",
		"ExternalTools.Tooltip.LandingPageURL": "When this external tool is used in an exam, this is the first page that the student will see.",
		"ExternalTools.Tooltip.CanEditLandingPage.P1": "Activating this setting makes it possible for the teacher to edit the landing page that has been set by the account manager.",
		"ExternalTools.Tooltip.CanEditLandingPage.P2": "The account manager can also choose to leave the landing page blank when this setting is activated." +
			" However, if it is left blank, it will be mandatory for the teacher to add a landing page when the external tool is used in an exam.",
		"ExternalTools.Tooltip.AllowLists.P1.title": "Allow single web pages",
		"ExternalTools.Tooltip.AllowLists.P1.body": "Will allow a student to browse the contents of only the web URL(s) added",
		"ExternalTools.Tooltip.AllowLists.P2.title": "Allow whole domains",
		"ExternalTools.Tooltip.AllowLists.P2.body": "Will allow a student to browse and navigate freely under the specified domain(s) without any limits",
		"ExternalTools.Tooltip.AllowLists.P3.title": "Allow partial access to domains",
		"ExternalTools.Tooltip.AllowLists.P3.body": "Will allow a student to browse and navigate freely under the specified URL path added. It is possible go deeper within the same URL path as long as it does not change, but it is not possible to up a level in the specific URL path specified here.",
		"ExternalTools.Tooltip.AllowList.LandingPage": "This is the landing page, it is always added as a single web page.",
		"ExternalTools.Tooltip.StudentEquipmentChecks": "Activate equipment checks when using external tools like video conferencing or meeting tools that require student equipment such as camera and/or microphone." +
			" This will prompt the operating system the student is using to give Digiexam permission to use the equipment that has been activated.",
		"ExternalTools.InternetWarning": "The student must be connected to the internet to use the external tool.",
		"ExternalTools.DeleteWarning.Title": "Are you sure you want to delete {0}?",
		"ExternalTools.DeleteWarning.Body.UsedInTemplates": "This external tool is being used in {0} exam templates. It will still be available in active and ended exams that it is enabled for.",
		"ExternalTools.DeleteWarning.Body.NotUsedInTemplates": "After this external tool is deleted, it will still be available in active and ended exams that it is enabled for.",
		"ExternalTools.SuccessfullyAddedInfo": "The external tool was successfully added",
		"ExternalTools.SuccessfullySavedInfo": "The external tool was successfully saved",
		"ExternalTools.SuccessfullyDeletedInfo": "The external tool {0} was successfully deleted",
		"ExternalTools.SuccessfullyAddedUrl": "The URL {0} was successfully added",
		"ExternalTools.SuccessfullyAddedLandingPageUrl": "The landing page URL {0} was successfully added",
		"ExternalTools.CouldNotSaveError": "Your changes could not be saved",
		"ExternalTools.CouldNotLoadError": "External tool could not be loaded",
		"ExternalTools.CouldNotLoadError.Plural": "External tools could not be loaded",
		"ExternalTools.CouldNotDeleteError": "The external tool {0} could not be deleted",
		"ExternalTools.EnterNameError": "Please enter a tool name to save",
		"ExternalTools.NameTooLongError": "A tool name may not be longer than {0} characters",
		"ExternalTools.EnterLandingPageError": "Please enter a landing page URL to save",
		"ExternalTools.SetIcon": "Set icon for {0}",
		"ExternalTools.SomeDeletedWarning.Title": "Some external tools have been deleted",
		"ExternalTools.SomeDeletedWarning.Body": "The following external tool(s) have been deleted: <strong>{0}</strong>. They can no longer be used in future exams.",
		"ExternalTools.SomeDeletedWarning.OnExamStart": "The following external tool(s) have been deleted: <strong>{0}</strong>. They won't be available in this exam.",

		"ExternalToolSettings.EnterLandingPageError": "You need to set a landing page for external tool \"{0}\".",

		"ExternallyManaged": "Externally managed",
		"ExternallyManagedExplanation": "This role is managed in another system outside of Digiexam. You must use the other system to change the role and then those changes will show up in Digiexam the next time you log in to Digiexam through that system.",
		"OnlyExternallyManagedRolesExist": "This organization has roles that are managed in another system outide of Digiexam but no roles that are managed by Digiexam. You cannot invite users to externally managed roles from within Digiexam.",
		"PrintSettings.Heading": "Print settings",
		"PrintSettings.HeadingClose": "Close print settings",
		"PrintSettings.PageBreaks.Title": "Page breaks",
		"PrintSettings.PageBreaks.Disabled": "No page breaks",
		"PrintSettings.PageBreaks.ExamTitle": "After title",
		"PrintSettings.PageBreaks.Student": "Before each student",
		"PrintSettings.PageBreaks.Question": "Before each question",
		"PrintSettings.DoubleLineSpacing.Title": "Double line spacing",
		"PrintSettings.DoubleLineSpacing.Description": "Show a blank line between every line of text.",
		"PrintSettings.AddBlankPage": "Separate by blank page",
		"PrintSettings.SortBy.Students": common.students,
		"PrintSettings.SortBy.Questions": common.questions,
		"PrintSettings.ExcludeUnansweredQuestions.Title": "Exclude unanswered questions",
		"PrintSettings.HideStudentNames.Title": "Hide student names",
		"PrintSettings.HideStudentNames.Description": "When student names are hidden, students are reordered by student code",
		"PrintSettings.NameSettings.Title": "Name settings",
		"PrintSettings.NameSettings.body1": "At least one option needs to be selected.",
		"PrintSettings.NameSettings.body2": "If several options are selected, they have the following order:",
		"PrintError.Heading": "Printing error",
		"PrintError.Info": "An error occurred while getting the document.",
		"EditClassName": "Edit class name",
		"EnterNewClassName": "Enter new class name",
		"NewClassName": "New name",
		"Referral.ReferFriends": "Refer friends and colleagues",
		"Referral.ReferFriendsMotivation": "Invite friends and colleagues to sign up for Digiexam and experience the great benefits!",
		"Referral.ShareLink": "You can also invite by sharing a link:",
		"Referral.EmailsSendSuccessful": "The e-mails are on their way! Thank you for recommending Digiexam!",
		"Referral.EmailsSendError": "The e-mails were not sent due to a technical error. Please try again. If the problem persists, please contact support.",
		"Referral.MustBeValidEmail": "Must be a valid e-mail address",
		"Referral.AtLeastOneEmailInvalid": "At least one of the e-mail addresses is not valid. Correct the invalid e-mail address before sending.",
		"Referral.EnterAtLeastOneEmail": "Enter at least one e-mail address before sending.",
		"RandomizeTheOrderOfQuestions": "Randomize the order of questions",
		"RandomizeTheOrderOfAlternatives": "Randomize the order of alternatives",
		"OpenBookExam": "Open book exam",
		"AnonymousExam": "Anonymous exam",
		"StudentComputerLockdown": "Student computer lockdown",
		"StudentComputerLockdown.Description.On": "Students can not surf the web or use other applications during the exam.",
		"StudentComputerLockdown.Description.Off": "Students can surf the web and use other applications during the exam.",
		"StudentComputerLockdown.Help": "Students can surf the web and access other applications on the computer during the exam.",
		"StudentComputerLockdown.Info1": "In student computer lockdown mode, students are prevented from surfing the web or accessing other applications on the computer during the exam.",
		"StudentComputerLockdown.Info2": "Turn on for formal exams.",
		"StudentComputerLockdown.Info3": "Turn off if the students are completing an open book exam or working on an assignment for which they are allowed to surf the web and use other applications.",
		"RemoteProctoringEnabled": "Remote Proctoring",
		"RemoteProctoringEnabled.Info1": "Enables you, proctors, and administrators to access students' webcams, microphones, and screens during an ongoing exam, as well as review the recordings after the exam has ended.",
		"RemoteProctoringEnabled.Description": "Students' activity will be monitored and recorded during the exam process.",
		"AllowExternalPaste": "Allow copy-pasting of text in the exam",
		"AllowExternalPaste.Info1": "Turn on to allow students to copy-paste text into their answers. In lockdown mode, only text from within the exam (Public exam description, Questions and allowed web links) is possible to use.",

		"General": "General",
		"ExamSettings": "Exam settings",
		"ExamSettingsInfo.Title": "Settings selected for this exam",
		"ExamSettingsInfo.AnonymousExam.Title": "Anonymous exam",
		"ExamSettingsInfo.AnonymousExam.Info1": "Student names are not visible to teachers during grading. The user that starts the exam can remove the anonymization when the exam is graded.",
		"ExamSettingsInfo.AnonymousExam.Info2": "To support exams where anonymous grading is a requirement, the exam should be started from the Exam administrator role.",
		"ExamSettingsInfo.AnonymousExam.Description": "Student names are not visible to teachers during grading.",
		"ExamSettingsInfo.DurationSetting.Title": "Time limited exam",
		"ExamSettingsInfo.DurationSetting.Description": "Students must hand in {0} hours and {1} minutes after they have started the exam.",
		"ExamSettingsInfo.SpellcheckAllowedForAllStudents.Title": "Spell check allowed",
		"ExamSettingsInfo.SpellcheckAllowedForAllStudents.Description": "All students are able to use spell check during the exam.",
		"ExamSettingsInfo.SpellcheckAllowedForSelectedStudents.Title": "Spell check when needed",
		"ExamSettingsInfo.SpellcheckAllowedForSelectedStudents.Description": "Selected students are able to use spell check during the exam.",
		"ExamSettingsInfo.TextToSpeechAllowedForAllStudents.Title": "Text to speech allowed",
		"ExamSettingsInfo.TextToSpeechAllowedForAllStudents.Description": "All students are able to use text to speech during the exam.",
		"ExamSettingsInfo.TextToSpeechAllowedForSelectedStudents.Title": "Text to speech when needed",
		"ExamSettingsInfo.TextToSpeechAllowedForSelectedStudents.Description": "Selected students are able to use text to speech during the exam.",
		"ExamSettingsInfo.UsbAudioAllowedForAllStudents.Title": "USB audio playback allowed",
		"ExamSettingsInfo.UsbAudioAllowedForAllStudents.Description": "All students are able to play audio files from an inserted USB during the exam.",
		"ExamSettingsInfo.UsbAudioAllowedForSelectedStudents.Title": "USB audio playback when needed",
		"ExamSettingsInfo.UsbAudioAllowedForSelectedStudents.Description": "Selected students are able to play audio files from an inserted USB during the exam.",
		"ExamSettingsInfo.ImmersiveReaderAllowedForAllStudents.Title": "Immersive Reader allowed",
		"ExamSettingsInfo.ImmersiveReaderAllowedForAllStudents.Description": "All students are able to use the Immersive Reader.",
		"ExamSettingsInfo.ImmersiveReaderForSelectedStudents.Title": "Immersive Reader allowed when needed",
		"ExamSettingsInfo.ImmersiveReaderForSelectedStudents.Description": "Selected students are able to use the Immersive Reader.",
		"ExamSettingsInfo.randomizedQuestions.Title": "Random questions order",
		"ExamSettingsInfo.randomizedQuestions.Description": "The order of the questions displayed to students during the exam is randomized.",
		"ExamSettingsInfo.randomizedQuestions.Info1": "The order of the questions displayed to students during the exam is randomized. The order is restored when you grade the exam.",
		"ExamSettingsInfo.randomizedAlternatives.Title": "Random alternatives order",
		"ExamSettingsInfo.randomizedAlternatives.Description": "The order of the alternatives for each question displayed to students during the exam is randomized.",
		"ExamSettingsInfo.randomizedAlternatives.Info1": "The order of the alternatives for each question displayed to students during the exam is randomized. The order is restored when you grade the exam.",
		"ExamSettingsInfo.lockedQuestionSequence.Title": "Locked question sequence (MEQ)",
		"ExamSettingsInfo.lockedQuestionSequence.Description": "The sequence of the questions is locked in the exam. A student cannot go back to an answered question to edit their answer.",
		"ExamSettingsInfo.ExternalTools.Title": "Enabled external tools",
		"ExamSettingsInfo.AllowExternalPaste.Title": "Allow copy-pasting of text in the exam",
		"ExamSettingsInfo.AllowExternalPaste.Info.On": "Students can copy/paste text from exam questions and external resources into their answers",
		"ExamSettingsInfo.AllowExternalPaste.Info.Off": "Students can not copy/paste text from exam questions and external resources into their answers",

		"On": common.on,
		"Off": common.off,
		"ReadMore": "Read more",

		"Support.HowToUseDigiExam": "How to use Digiexam",
		"Support.WeHaveUserGuides": "We have user guides available for teachers, students and administrators on how to use Digiexam. You can also find other documentation such as system requirements and installation guides.",
		"Support.GoToKnowledgeCenter": "Go to knowledge center",
		"Support.DownloadClient": "Download client",
		"Support.AsAStudentYouNeed": "As a student you need to download and install the client in order to write an exam. If you are a teacher you can download the client to test an exam from a student perspective.",
		"Support.GoToInstallationGuides": "Go to installation guides",
		"Support.ContactUs": "Contact us",
		"Support.NeedMoreHelp.ChatWithUs": "Chat with us: You can find the chat bubble in the bottom right corner of the page. (If you don't see it, try clearing your browser cache).",
		"Support.NeedMoreHelp.EmailUs": "Email us: You can reach us at <a href='{0}'>{1}</a>",
		"Support.ThisSupportFeatureIsOnly": "This support feature is only available to paying customers. Get in touch with our sales team for more info at <a href='{0}'>{1}</a>",
		"Support.SalesMailSubject": "Basic to Premium",
		"Support.SalesMailBody": "Hi!\n\nPlease contact me with pricing information regarding Digiexam.\n\nName: \nPhone number: \nSchool: \nRole: ",
		"Support.OrCheckOut1": "or check out the",
		"Support.OrCheckOut2": "or our",
		"Support.DigiExamIntro": "Intro to Digiexam",
		"Support.PinInfo": "This PIN is used to verify your identity when contacting us. It is updated once per day.",
		"Support.Error": "Support chat is currently down, please try again or contact support through email: {0}",
		"Support.ContactAccountManager.Title": "Account Managers",
		"Support.ContactAccountManager.Content": "Do you need to create students, invite users or are you missing a role? " +
			"Contact one of the account managers on your school/organization.",
		"Support.ContactAccountManager.Empty": "There are no account managers on your school/organization.",
		"Support.ContactAdmin.Title": "Administrators",
		"Support.ContactAdmin.Content": "Do you need to remove anonymization from an exam? Contact one of the administrators on your school/organization.",
		"Support.ContactAdmin.Empty": "There are no administrators on your school/organization.",

		"LTI.CouldNotSendAllGrades": "Could not send all grades",
		"LTI.WeEncounteredProblems": "Unfortunately, we encountered some problems when sending the grades to your LMS. The grades for the following students were not possible to send and we recommend that you enter their grades manually in your LMS",
		"LTI.SelectedExam": "Selected exam",
		"LTI.FillInInYourLMS": "Add this to your LMS assignment",
		"Course.LMSManaged.title": "Digiexam works with your LMS",
		"Course.LMSManaged.paragraph.1": "Courses from your Learning Management System (LMS) appear here after you have used Digiexam exams in them.",
		"Course.LMSManaged.paragraph.2": "Select a course to find the exams that you have used and students who have registered to take exams.",
		"Course.SkolonManaged.title": "Digiexam integrates with Skolon",
		"Course.SkolonManaged.paragraph.1": "Your Skolon groups and students are synced into Digiexam from Skolon when you login. You may use these groups to start exams with.",
		"Course.SkolonManaged.paragraph.2": "Changes to the groups (such as adding/removing students or teachers) must be made within Skolon in order to take affect in Digiexam when you login again.",
		"Info": "Info",

		"NoExamSelected": "No exam selected",
		"ToSelectAnExam": "To select an exam",
		"GotToSettingsForThisAssignmentInLMS": "Go to settings for this assignment in your Learning Management System",
		"ChooseDigiExamAsTheExternalTool": "Choose Digiexam as the external tool",
		"ChooseAnExamFromYourExamLibraryInDigiExam": "Choose an exam from your exam library in Digiexam",
		"YouHaveNotStartedThisExamYet": "You have not started this exam yet",
		"TipDoNotSetStartAndEndDatesInLMS": "Tip! Do not set start and end dates in your LMS",
		"TipDoNotSetStartAndEndDatesInLMS.Info": "If you leave start and end dates blank in your Learning Management System, students will be able to register for the exam through their LMS accounts and get access to their login details before you start the exam. They will also be able to see grades and feedback when the exam is finished and you have published the results.",
		"YouNeedToEndTheExamInDigiExam": "You need to end the exam in Digiexam",
		"ViewExamInDigiExam": "View exam in Digiexam",
		"GradeExamInDigiExam": "Grade exam in Digiexam",
		"ResultsPublishedTo": "Results published from Digiexam to",
		"WaitForYourTeacherToAddAnExam": "Wait for your teacher to add an exam...",
		"LearnMoreAboutTakingAnExamInDigiExam": "Learn more about taking an exam with Digiexam",
		"IsOpenForRegistration": "is open for registration",
		"RegisterMe": "Register me",
		"WhenYouHaveRegistered.Info": "When you have registered, you will get access to your login details which you will need to start the exam in Digiexam.",
		"UnableToRegister": "Unable to register",
		"UnableToRegister.Info": "We were unable to register you for this exam.",
		"YouHaveRegisteredFor": "You have registered for",
		"YourTeacherWillLetYouKnow.Info": "Your teacher will let you know when this exam will start. When it has started, open the Digiexam client and enter your login details:",
		"DontHaveTheClient": "Don't have the client?",
		"DownloadItHere": "Download it here",
		"YouHaveStarted": "You have started",
		"ToContinueWritingTheExam.info": "To continue writing the exam, open the Digiexam client. Your teacher may need to unlock your exam.",
		"YouHaveHandedInYourAnswersFor": "You have handed in your answers for",
		"CheckBackHereLater.Info": "Check back here later for grade and feedback from your teacher.",
		"HasEnded": "has ended",
		"FeedbackFromYourTeacher": "Feedback from your teacher",
		"SeeMoreDetailedFeedbackOnYourDigiExamAccount": "See more detailed feedback on your Digiexam account.",
		"GoToDigiExam": "Go to Digiexam",
		"ExamAccessRestrictedToOwner": "Only the owner has access to the exam in Digiexam",
		"StartNow": "Start now",
		"Move": "Move to group",
		"MenuItem.Groups": "Groups",
		"MenuItem.Rubrics": common.rubrics,
		"MenuItem.RolesAndUsers": "Roles & Users",
		"AddSelectedQuestions": "Add selected questions",

		"Overview.CreateExam": common.createNewExam,
		"StudentsAbsentOrUsedPenAndPaper": "Absent or used pen & paper",
		"Update": "Update",
		"WebLinks": "Web links",
		"WebLink": "Web link",

		"Region.Title": "Region",
		"Region.ChangeRegion": "change",
		"Region.ChooseRegion": "Choose region",
		"Region.Europe": "Europe",
		"Region.USA": "USA",
		"Region.Other": common.other,
		"Region.Development": "Dev",

		"Login.UserWrongRegionPopupTitle": "Your account belongs to another region",
		"Login.UserWrongRegionPopupBody": "It seems your account is currently registered on our servers in {0} so we changed the region for you. Please try logging in again.",
		"Login.TryAgain": "Try again",
		"Login.Europe": "Europe",

		"Exams.Exams": common.exams,
		"Exams.CreateExam": common.createNewExam,
		"Exams.Archive": common.archiveNoun,
		"Exams.ImportedExam": "Imported exam",
		"Exams.SharedExam": "Shared exam",
		"Exams.SharedExamNotice": "Note: The grading for this exam is shared with additional teachers. Your changes may be overwritten by others.",
		"Exams.Import": "Import",
		"Exams.Library": "Exam library",
		"Exams.Scheduled": "Scheduled",
		"Exams.Ongoing": "Ongoing",
		"Exams.Ungraded": "Ungraded",
		"Exams.Graded": "Graded",
		"Exams.Published": "Published",
		"Exams.ScheduledArchived": "Scheduled (Archived)",
		"Exams.OngoingArchived": "Ongoing (Archived)",
		"Exams.UngradedArchived": "Ungraded (Archived)",
		"Exams.GradedArchived": "Graded (Archived)",
		"Exams.PublishedArchived": "Published (Archived)",
		"Exams.Library.NoExams": "Your Exam library is empty. Click on “Create new exam”.",
		"Exams.Scheduled.NoExams": "You have no scheduled exams.\nSchedule an exam from the Exam library.",
		"Exams.Ongoing.NoExams": "You have no ongoing exams.\nStart an exam from the Exam library.",
		"Exams.Ungraded.NoExams": "You have no ungraded exams.",
		"Exams.Graded.NoExams": "You have no graded exams.",
		"Exams.Published.NoExams": "You have no published exams.",
		"Exams.OwnedBy": "Owned by: ",
		"Exams.SharedWith": "Users who have access to: ",

		"Error.LoadingExams": "Error loading exams",
		"Error.LoadingInvigilatorSettings": "Error loading invigilator settings",
		"Error.Title": "Oops, something went wrong",
		"Error.Message": "Error message",
		"Error.SyncIssue": "There was an issue syncing data into Digiexam, check below for a detail of the issue.",
		"Error.ContactUs": "Contact support@digiexam.com if you need support with resolving this problem.",
		"Error.ContactUsSkolon": "Contact support@digiexam.se if you need support with resolving this problem.",

		"Rubrics.Rubrics": common.rubrics,
		"Rubrics.CreateRubric": "+ Create new rubric",
		"Rubrics.Archive": common.archiveNoun,
		"Rubrics.RemoveRubric": "Remove rubric",
		"Rubrics.Library.NoRubrics": "Your Rubrics library is empty. Click on “Create new rubric”.",
		"Rubrics.RemoveSharedRubric": "Remove shared rubric",
		"Rubrics.ThePersonWhoSharedTheRubricWillStillHaveAccessToIt": "The person who shared the rubric will still be able to access it.",

		"StartExamPopup.Start": "Start",
		"StartExamPopup.StartTime": common.startTime,
		"StartExamPopup.Participants": "Participants",
		"StartExamPopup.UseExamID": "Use exam ID",
		"StartExamPopup.ChooseGroup": "Choose group",
		"StartExamPopup.StartExamNow": "Start exam now",
		"StartExamPopup.ScheduleExam": "Schedule exam",
		"StartExamPopup.TooltipExamIDStartNow": "You get the exam ID when you click \"Start exam now\". Remember to share this exam ID with the students that are taking the exam.",
		"StartExamPopup.TooltipExamIDSchedule": "You get the exam ID when you click \"Schedule exam\". Remember to share this exam ID with the students that are taking the exam.",
		"StartExamPopup.TooltipGroup": "If you start the exam for a specific group, it will automatically show up for the students when they log in to the client and they won't have to enter an exam ID.",
		"StartExamPopup.LearnMore": "Learn more",
		"StartExamPopup.CouldNotStartExam": "Could not start/reschedule your exam.",
		"StartExamPopup.CouldNotLoadGroups": "Could not load your groups.",
		"StartExamPopup.NoGroups": "You have not created any groups.",
		"StartExamPopup.StartDateNeeded": "You need to set a start date.",
		"StartExamPopup.StartDateTooEarly": "Start date can't be earlier than now.",
		"StartExamPopup.StartDateInvalid": "Date must be written as \"YYYY-MM-DD\".",
		"StartExamPopup.StartNow": "You are about to start",
		"StartExamPopup.For": "for",
		"StartExamPopUp.RequireInternetConnection": "This exam contains web links. The student must be connected to the Internet during the exam to access the content of the links.",
		"StartExamPopup.IncompleteExam": "This exam-template is incomplete. Please fill in the missing information before starting.",
		"StartExamPopup.EditExam": "Edit the exam",

		"EditExamPopup.ExistingExams.Title": "Existing exams",
		"EditExamPopup.ExistingExams.Body": "You will be editing the exam template. Existing exams started from this template won't be affected. You can schedule or start a new exam from the updated template after making any changes.",

		"Invigilator.TooltipInfo": "Invigilators, also known as proctors, are able to gain access to the exam overview during a scheduled exam to assist the teacher with administration. You can define what permissions they have access to, such as starting/stopping the exam, or locking/unlocking students, etc.",
		"Invigilator.InviteInvigilator": "Invite invigilator",
		"Invigilator.InvigilatorInvitesPendingStartNow": "The invitations will be sent when you click \"Start exam now\".",
		"Invigilator.InvigilatorInvitesPendingSchedule": "The invitations will be sent when you click \"Schedule exam\".",
		"Invigilator.AddInvigilatorInvite": "Add invite",
		"Invigilator.PerformInvigilatorInvite": "Invite invigilator",
		"Invigilator.PlannedInvigilatorInvites": "Invigilator invitations",
		"Invigilator.PendingInvigilatorInvites": "Invited Invigilators",
		"Invigilator.NoInvigilators": "No invigilators have been invited to this exam",
		"Invigilator.Settings.Title": "Invigilator settings",
		"Invigilator.Settings.StartExam": "Start exam",
		"Invigilator.Settings.EndExam": "End exam",
		"Invigilator.Settings.LockUnlockExam": "Lock and unlock exam",
		"Invigilator.Settings.DownloadExam": "Download offline exam file",
		"Invigilator.Error.AlreadyExists": "Email is already added",
		"Invigilator.Error.InvalidEmail": common.errors.invalidEmail,
		"Invigilator.Error.LoadError": "Could not load invigilators",
		"Invigilator.Error.CreateError": "Could not invite invigilator",
		"Invigilator.Save": "Save invigilator changes",

		"ExamInfoPopup.HasStarted": "has started",
		"ExamInfoPopup.HasBeenScheduled": "has been scheduled",
		"ExamInfoPopup.WillAutoStart": "will automatically start",
		"ExamInfoPopup.ShareExamId": "You need to share the exam ID with the students writing the exam.",
		"ExamInfoPopup.YouHaveStarted": "You have started",
		"ExamInfoPopup.ForGroup": "for group",
		"ExamInfoPopup.Download": "Download offline exam file",
		"ExamInfoPopup.At": "at",
		"ExamInfoPopup.DownloadInfo1": "Save the offline exam file to a USB drive and bring it to the exam. The USB drive can be used to:",
		"ExamInfoPopup.DownloadInfo2": "- Start  an exam for a student that can't start online.",
		"ExamInfoPopup.DownloadInfo3": "- Change accessibility settings.",

		"Overview.SeeAllOngoingExams": "See all ongoing exams",
		"Overview.SeeAllUngradedExams": "See all ungraded exams",
		"Overview.SeeAllScheduledExams": "See all scheduled exams",

		"SearchSortFilter.Sort": "Sort",
		"SearchSortFilter.DateModified": common.dateModified,
		"SearchSortFilter.Title": "Title",
		"SearchSortFilter.Subject": "Subject",
		"SearchSortFilter.Description": "Description",
		"SearchSortFilter.StartTime": common.startTime,
		"SearchSortFilter.FilterByTitleOrDescription": "Filter by title or description",
		"SearchSortFilter.FilterByTitleOrSubject": "Filter by title or subject",
		"SearchSortFilter.FilterByTitleExamIDOrGroup": "Filter by title, exam ID or group",

		"ExamEntry.DateModified": common.dateModified,
		"ExamEntry.StartTime": common.startTime,

		"RubricEntry.DateModified": common.dateModified,

		"Spellcheck.SettingField.Title": "Allow spell check for",
		"Spellcheck.SettingField.Tooltip": "Allow spell check for individual students by clicking on \"Students\" in the left hand menu, find the student and change this under Accessibility settings.",
		"Spellcheck.Setting.0": "Only selected students",
		"Spellcheck.Setting.1": "All students",
		"Spellcheck.Setting.2": "No students",

		"ExamAdminEmails.AddTitle": "Add exam admin email",
		"ExamAdminEmails.Title": "Exam admin emails",

		"TotalSumCopy.Label": "Use total sum",

		"Import.Title": "Import exams and questions",
		"Import.Paragraph.1": "Import exams and questions from an external source and use in Digiexam. Imported exams will pop up in your exam library.",
		"Import.Paragraph.2": "We currently support QTI 1.2, Common cartridge (IMSCC) and Content package. This means that you can import questions from e.g. Canvas, Blackboard, Moodle, Sakai, Schoology and Powerschool.",
		"Import.Paragraph.3": "Please note that we only support questions that can be imported as a Multiple choice, Multiple response or Text question. Learn more about exporting and importing questions in our",
		"Import.KnowledgeCenter": "Knowledge center",
		"Import.DropArea.DropFilesHere": "Drop files here or click to browse.",
		"Import.DropArea.AllowedFileFormats": "Allowed file formats are .zip, .xml and .imscc",
		"Import.Results.Title": "Exams and questions",
		"Import.Results.ExamTitle": "Exam title",
		"Import.Results.ImportedQuestions": "Imported questions",
		"Import.Results.ViewReport": "View report",
		"Import.Results.ReportTitle": "Report for",
		"Import.Results.FilePath": "File path",
		"Import.Results.QuestionTitle": "Question title",
		"Import.Results.ImportedAs": "Imported as",
		"Import.Results.NotSupported": "Not imported: question type not supported",
		"Import.Results.CouldNotImport": "Not imported: question could not be parsed",
		"Import.Importing": "Importing",
		"Import.Restart": "Import another file",
		"Import.ViewImported": "View imported exams",

		"Uploadarea.InvalidFormat": "The following files have invalid file types and could not be added:",

		"QuestionType.UNIDENTIFIED": "Unknown question type",
		"QuestionType.TRUE_FALSE": "True / False",
		"QuestionType.MULTIPLE_RESPONSE": "Multiple response",
		"QuestionType.MULTIPLE_CHOICE": "Multiple response",
		"QuestionType.ESSAY": "Essay",
		"QuestionType.FILL_IN_BLANK": "Fill in the blank",
		"QuestionType.FILL_IN_MULTIPLE_BLANKS": "Fill in multiple blanks",
		"QuestionType.MULTIPLE_DROWDOWNS": "Multiple dropdowns",
		"QuestionType.MATCHING": "Matching",
		"QuestionType.NUMERICAL": "Numerical answer",
		"QuestionType.CALCULATED": "Calculated",
		"QuestionType.FILE_UPLOAD": "File upload",
		"QuestionType.TEXT_ONLY": "Text",
		"QuestionType.EITHER_OR": "Either / Or",
		"QuestionType.HOT_SPOT": "Hot spot",
		"QuestionType.OPINION_SCALE": "Opinion scale",
		"QuestionType.ORDERING": "Ordering",
		"QuestionType.QUIZ_BOWL": "Quiz bowl",
		"QuestionType.SHORT_RESPONSE": "Short response",
		"QuestionType.AUDIO_RESPONSE": "Audio response",
		"QuestionType.SURVEY_MATRIX": "Survey matrix",
		"QuestionType.PATTERN_MATCH": "Pattern match",

		"OnlineResourcePopup.Title": common.title,
		"OnlineResourcePopup.Cancel": common.cancel,
		"OnlineResourcePopup.Add": common.add,
		"OnlineResourcePopup.Edit": common.edit,
		"OnlineResourcePopup.SaveLink": common.save,
		"OnlineResourcePopup.AddLink": "Add Link",
		"OnlineResourcePopup.WholeDomain": "Whole domain",
		"OnlineResourcePopup.SingleWebPage": "Single web page",
		"OnlineResourcePopup.WebAddress": "Web address (URL)",
		"OnlineResourcePopup.RequireInternetConnection": "The student must be connected to the Internet during the exam to access the content of this link.",
		"OnlineResourcePopup.VideoLink": "YouTube link",
		"OnlineResourcePopup.AudioLink": "audio link",
		"OnlineResourcePopup.PdfLink": "PDF link",
		"OnlineResourcePopup.WebPageLink": "web link",
		"OnlineResourcePopup.SingleWebPageTooltip": "The student can only access the page you have chosen. Links on the page are blocked and the student is restricted from navigating to other pages and domains.",
		"OnlineResourcePopup.WholeDomainTooltip": "The student has access to all pages on the chosen domain. Any links that lead to pages on other domains are blocked.",
		"OnlineResourcePopup.TitleError": "You need to enter a title.",
		"OnlineResourcePopup.UrlErrorProtocol": "You can only link to a web address.",
		"OnlineResourcePopup.UrlErrorEmpty": "You need to enter a URL.",
		"OnlineResourcePopup.YoutubeError": "This is not a YouTube video.",
		"OnlineResource.SuggestedTitle1": "Title suggestion: ",
		"OnlineResource.unreachableURL": "We can't reach the web address. Are you sure it's correct?",
		"OnlineResource.InternetWarning": "Note: Students must have an active internet connection to use media links.",

		"OnlineResourceAddMedia.Audio": "Audio",
		"OnlineResourceAddMedia.WebPage": "Web page",
		"OnlineResourceAddMedia.AddMedia": "Add media",

		"OnlineResourceEntry.WholeDomain": "Whole domain",
		"OnlineResourceEntry.SingleWebPage": "Single web page",
		"OnlineResourceEntry.Remove": common.remove,
		"OnlineResourceEntry.PopupTitle": "Important information",
		"OnlineResourceEntry.PopupDescription": "When the student opens this link during the exam they will not be able to navigate to other pages.",
		"OnlineResourceEntry.IconAlt.YouTube": "YouTube link",
		"OnlineResourceEntry.IconAlt.Audio": "Audio link",
		"OnlineResourceEntry.IconAlt.PDF": "PDF link",
		"OnlineResourceEntry.IconAlt.WebPage": "Web link",

		"StudentExtendedTime.Allow": "Allow extended time for exams with time limit",
		"StudentExtendedTime.Limitless": "Remove time limit",
		"StudentExtendedTime.Percent": "Extend time by",

		"StudentRoute.Error.ExtendedTimePercentNotEntered": "Enter by how many percent exam time should be extended.",
		"StudentRoute.Error.ExtendedTimeStateNotSelected": "Remove time limit or extend time by percent.",

		"TextToSpeech.SettingField.Title": "Allow text to speech for",
		"TextToSpeech.SettingField.Tooltip": "Text to speech allows students to listen to text. Allow text to speech for individual students by clicking on \"Students\" in the left hand menu, find the student and change this under Accessibility settings.",
		"TextToSpeech.Setting.0": "Only selected students",
		"TextToSpeech.Setting.1": "All students",
		"TextToSpeech.Setting.2": "No students",
		"TextToSpeech.AllowForStudent": "Allow text-to-speech for this student",

		"ExamDuration.TimeLimit": "Time limit",
		"ExamDuration.hours": "hours",
		"ExamDuration.minutes": "minutes",
		"ExamDuration.AllowExtended": "Allow extended time for selected students",
		"ExamDuration.TimeLimitToolTip": "The timer starts individually for each student when they start the exam. When the timer runs out, the exam is automatically handed in. The teacher is able to extend or remove the time limit for individual students during and after the exam. This is done with the help of a USB device containing the offline exam file (not supported on iPad).",
		"ExamDuration.AllowExtendedToolTip": "For students with special accommodations, you can extend or remove the time limit. Go to \"Students\" in the left hand menu, find the student and change this under Accessibility settings.",
		"ExamDuration.ErrorMessage": "Time limit must have a duration longer then 0 minutes",
		"ExamDuration.On": common.on,
		"ExamDuration.Off": common.off,

		"UsbAudio.SettingField.Title": "Allow audio playback from USB for",
		"UsbAudio.SettingField.Tooltip": "Audio playback from a USB drive allows students to listen to audio files within the client. Allow audio playback for individual students by clicking on \"Students\" in the left hand menu, find the student and change this under Accessibility settings.",
		"UsbAudio.Setting.0": "Only selected students",
		"UsbAudio.Setting.1": "All students",
		"UsbAudio.Setting.2": "No students",
		"UsbAudio.AllowForStudent": "Allow audio playback from USB drive",

		"ImmersiveReader.SettingField.Title": "Allow Immersive Reader to be used for",
		"ImmersiveReader.SettingField.Tooltip.RequireInternetConnection": "The student must be connected to the Internet during the exam to use Immersive Reader.",
		"ImmersiveReader.SettingField.Tooltip.Description": "Immersive Reader is a learning tool that offers students reading support visually, grammatically and verbally. Allow Immersive Reader for individual students by clicking on \"Students\" in the left hand menu, find the student and change this under Accessibility settings. ",
		"ImmersiveReader.Setting.0": "Only selected students",
		"ImmersiveReader.Setting.1": "All students",
		"ImmersiveReader.Setting.2": "No students",
		"ImmersiveReader.AllowForStudent": "Allow Immersive Reader to be used",

		"GradingOptions": "Grading options",
		"GradingOptions.AllOrNothing": "All or nothing",
		"GradingOptions.AllOrNothing.Tooltip": "The student must answer everything correctly to get the max points. If the student miss to answer anything or answer something incorrectly, the student is awarded zero points.",
		"GradingOptions.RightMinusWrong": "Right minus wrong",
		"GradingOptions.RightMinusWrong.Tooltip": "The student gets plus points for each correct answer and minus points for each incorrect answer. Each answer is worth the max points of the question divided by the number of potentially correct alternatives. The minimum points awarded is zero.",
		"GradingOptions.PointsPerResponse": "Points per response",
		"GradingOptions.PointsPerResponse.Tooltip": "The student gets plus points for each correct answer. Each correct answer is worth the max points of the question divided by the number of potentially correct alternatives. Points will not be deducted for incorrect answers. The minimum points awarded is zero.",
		"GradingOptions.LimitedAlternatives": "Limited alternatives",
		"GradingOptions.LimitedAlternatives.Tooltip": "Limits how many alternatives the student can choose when answering the question.",
		"GradingOptions.LimitedAlternatives.ChoiceLimit": "Limit alternative choice to:",
		"GradingOptions.LimitedAlternatives.NumberOfAlternatives": "Number of alternatives",
		"GradingOptions.LimitedAlternatives.ChoiceLimit.Error": "Please choose a limit",
		"GradingOptions.LimitedAlternatives.Error": "One of your multiple response questions is using limited alternatives, but no limit has been chosen.\n" +
		"Choose a limit or turn limited alternatives off to solve the issue.",

		"MasterTools.BulkChangeEmail.Verify": "Verify bulk change e-mail",
		"MasterTools.BulkChangeEmail.Perform": "Perform bulk change e-mail",
		"MasterTools.BulkGdprDelete.Perform": "Perform bulk GDPR delete",
		"MasterTools.BulkUnifyPassword.Perform": "Perform bulk unify password",

		"Communication.Title": "Communication settings",
		"Communication.Terms.Title": "Changes to the terms of service",
		"Communication.System.Title": "System notifications",
		"Communication.ProductUpdates.Title": "Product updates",
		"Communication.Promotional.Title": "Promotional updates",

		"WordGap.MatchingOption.MatchingTitle": "Matching",
		"WordGap.MatchingOption.CaseSensitive": "Case sensitive",
		"WordGap.MatchingOption.ExactMatch": "Exact match. Student's response must be an exact match to the correct answer.",
		"WordGap.MatchingOption.Contains": "Contains. Student's response must contain the correct answer.",
		"WordGap.Validation.NoBlanks": "Question must contain at least one word gap.",
		"WordGap.Validation.EmptyBlanks": "Word gap cannot be empty. Please enter the correct answer.",

		"RedactedPii.StudentName": "[Deleted student]",

		"Tooltip.Show": "Show tooltip",
		"Tooltip.Note": "Note!",
		"Tooltip.MoreInfo": "More information on Digiexam’s Knowledge Center",

		"Accessibility.Flags.DisableFilters": "Disable filters",
		"Accessibility.Flags.Spellcheck": "Spellcheck",
		"Accessibility.Flags.TextToSpeech": "Text to speech",
		"Accessibility.Flags.ExtendedTime": "Extended time",
		"Accessibility.Flags.ImmersiveReader": "Immersive Reader",
		"Accessibility.Flags.AudioFiles": "Audio files",
		"Accessibility.Header.UsedTools": "Accessibility tools used during this exam",
		"Accessibility.Header.UsedTools.WithName": "Accessibility tools used by {0} during this exam",

		"Navigation.SkipToMainContent": "Skip to main content",

		"LiveView.UnlockAll": "Unlock all",
		"LiveView.LockAll": "Lock all",
		"LiveView.UnlockAll.Question": "Do you want to unlock the exam for all students?",
		"LiveView.LockAll.Question": "Do you want to lock the exam for all students?",
		"LiveView.UnlockExam": "Unlock exam",
		"LiveView.LockExam": "Lock exam",
		"LiveView.UnlockExam.Question": "Do you want to unlock the exam so that the student can start it?",
		"LiveView.LockExam.Question": "Do you want to lock the exam and prevent the student from starting it?",
		"LiveView.Tooltip.LockedExamsTitle": "Lockstatus: Unlocked and Locked",
		"LiveView.Tooltip.LockedExams": "A student can only start en exam that is open. As soon as the student enters the exam, it is locked and the material and aids that are allowed through the exam settings are available. When the student submits the exam, it remains locked but the student no longer has access to the exam.",
		"LiveView.Tooltip.LockUnlockTitle": "Lock all/Unlock all",
		"LiveView.Tooltip.LockUnlock": "Use this feature to lock or unlock all exams with one button press.",
		"LiveView.Tooltip.MoreInfo": "Read more about this feature.",
		"LiveView.Forbidden": "You don't have the correct permissions to view the exam.",

		"Schedule.Exam.Archive.Title": "Are you sure you want to archive {0}",
		"Schedule.Exam.Archive.Text": "You should notify any invigilators and students about the cancellation.",

		"ArticleList.Blog": "Blog Posts",
		"ArticleList.Blog.ShowAll": "Show all blogs..",
		"ArticleList.Support": "Support Articles",
		"ArticleList.Support.ShowAll": "Show all articles..",
		"ArticleList.Updated": "Updated at",
		"ArticleList.Created": "Created at",
		"ArticleList.Title": "Title",
		"ArticleList.NothingFound": "No articles found",
		"ArticleList.Error": "Failed to load articles",
		"ArticleList.New": "New",
		"ArticleList.ShowMore": "Show more..",
		"Grading.ScoreBasedValidation.ValidNumberError": "Only numbers are allowed during score based grading",
		"Grading.ScoreBasedValidation.MinError": "Points are not allowed to be below 0",
		"Grading.ScoreBasedValidation.MaxError": "Points are not allowed to be higher than the max points",

		"Archive.NoExamTemplates": "No exam templates are currently archived",
		"Archive.NoLiveExams": "No exams are currently archived",
		"Archive.NoRubrics": "No rubrics are currently archived",
		"Archive.NoCourses": "No courses are currently archived",
		"Archive.NoClasses": "No classes are currently archived",

		"Class.RemoveStudent": "Do you really want to remove \"{0}\" from {1}?",

		"ImportStudents.Title.Master": "Import Students",
		"ImportStudents.Title.AccountManager": "Import Students to {0}",
		"ImportStudents.SelectOrganization": "Select organization",
		"ImportStudents.StudentCodesDisabled": "Student codes are disabled on this organization",
		"ImportStudents.Notice1": "Notice",
		"ImportStudents.Notice2": "Before creating any Digiexam accounts, please make sure that the e-mail addresses used for the accounts are valid, active, and that they can receive e-mail. ",
		"ImportStudents.Notice3": "An introduction e-mail where the password can be set by the student is sent out when creating an account. " +
			"If an e-mail address is not valid or active, the introduction e-mail cannot be received and it cannot be sent again. " +
			"The introduction e-mail is sent out whether a password is provided or not for the student during import.",
		"ImportStudents.Notice4": "A student can always use the \"Forgot password\" feature on the login screen to create a new password if they cannot find the introduction e-mail.",
		"ImportStudents.Details1": "How to import",
		"ImportStudents.Details2": "Paste student info from a spreadsheet, format it as the example below. Duplicate addresses will be removed. Accessibility settings and password are optional fields. " +
			"Accessibility settings will be disabled for the student if not included. Password will be set by the student via the introduction e-mail or \"Forgot password\" feature if not included.",
		"ImportStudents.Details3": "Enable one or more accessibility settings by including the respective accessibility code. Accessibility settings can be changed at any time from the student page.",
		"ImportStudents.AccessibilityCodes": "Accessibility codes",
		"ImportStudents.StudentCode": "Student code",
		"ImportStudents.PasteLabel": "Paste students",
		"ImportStudents.Example.Title": "Format example",
		"ImportStudents.Example.Show": "Show example",
		"ImportStudents.Example.Hide": "Hide example",
		"ImportStudents.Example.Details": "Student information for Jane Doe with text to speech and spellcheck enabled. You can try the format by copying and pasting the example below.",
		"ImportStudents.Example.Email": "jane.doe@mail.com",
		"ImportStudents.Example.FirstName": "Jane",
		"ImportStudents.Example.LastName": "Doe",
		"ImportStudents.Example.StudentCode": "doe2365",
		"ImportStudents.Example.AccessibilityCodes": "accessibility codes*",
		"ImportStudents.Example.Optional.Note": "*optional to include",
		"ImportStudents.Example.Password": "Ozqtge9D0y28",
		"ImportStudents.StudentsToImport": "Students to import",
		"ImportStudents.StudentsImportOngoing1": "Student import {0}, see job {1} for info.",
		"ImportStudents.StudentsImportOngoing2": "{0}/{1} students imported.",
		"ImportStudents.Error.InvalidEmail": "E-mail on line {0} is not valid: {1}",
		"ImportStudents.Error.InvalidStudentCode": "Student code on line {0} is not valid: {1}",
		"ImportStudents.Error.InvalidFirstName": "First name on line {0} is not valid: {1}",
		"ImportStudents.Error.InvalidLastName": "Last name on line {0} is not valid: {1}",
		"ImportStudents.Error.InvalidAccessibilityCode": "Accessibility code \"{0}\" on line {1} is not valid: {2}",
		"ImportStudents.Error.InvalidPassword": "Password on line {0} is not valid: {1}",
		"ImportStudents.Error.InvalidColumnCount": "Expected row {0} to have between {1} and {2} columns, but it had {3}: {4}",
		"ImportStudents.Error.UnexpectedError": "Something went wrong during the student import, contact support if the issue persists.",
		"ImportStudents.Error.DuplicateEmails": "Found duplicate emails in rows: {0}",

		"CreateStudent.Error.UnexpectedError": "Something went wrong when creating a student, contact support if the issue persists.",
		"CreateStudent.Error.InvalidEmail": "E-mail is not valid",
		"CreateStudent.Error.InvalidStudentCode": "Student code is not valid",
		"CreateStudent.Error.InvalidFirstName": "First name is not valid",
		"CreateStudent.Error.InvalidLastName": "Last name is not valid",
		"CreateStudent.Error.AlreadyExists": "Student with this e-mail already exists",
		"CreateStudent.CreateSuccess": "Student has been successfully created,",
		"CreateStudent.CreateError": "Something went wrong when creating a student,",
		"CreateStudent.CreateLink": "click here for more info.",

		"LeaveWarning.Title": "Are you sure you want to leave this page?",
		"LeaveWarning.Body": "Any changes made will not be saved.",

		"ProctoringSettings.Title": "Remote proctoring settings",
		"ProctoringSettings.Warning": "At least one setting needs to be enabled.",
		"ProctoringSettings.Reset": "Reset to default settings",
		"ProctoringSettings.SaveSuccess": "Settings saved",
		"ProctoringSettings.MobileCamera.Title": "Additional mobile camera",
		"ProctoringSettings.MobileCamera.Body": "Adds a mobile / smartphone camera to the session in addition to the webcam. The student will connect a mobile / smartphone camera to the session using a QR code.",
		"ProctoringSettings.AutomaticConclusion.Title": "Automatic session conclusion",
		"ProctoringSettings.AutomaticConclusion.Body1": "The system can set an automatic conclusion (positive or negative) for each session based on the criterias from the setting “Track misuse metrics”.",
		"ProctoringSettings.AutomaticConclusion.Body2": "If the setting “Track misuse metrics” is not active, all sessions will automatically be set to a positive rating.",
		"ProctoringSettings.Chat.Title": "Student / proctor chat",
		"ProctoringSettings.Chat.Body": "Chat with students during the exam, file sharing in the chat is supported.",
		"ProctoringSettings.FacePhoto.Title": "Take photo of face at exam start",
		"ProctoringSettings.FacePhoto.Body": "The student will get a prompt to photograph their face when starting the exam (if this setting is disabled, the student face is photographed automatically in the first minutes after the exam starts).",
		"ProctoringSettings.IdPhoto.Title": "Take photo of ID at exam start",
		"ProctoringSettings.IdPhoto.Body": "The student will get a prompt to photograph a personal ID card when starting the exam.",
		"ProctoringSettings.RecordVideo.Title": "Record student screen and webcam during exam",
		"ProctoringSettings.RecordVideo.Body1": "Throughout the session, video is recorded of the webcam, computer screen and additional mobile camera.*",
		"ProctoringSettings.RecordVideo.Body2": "* Mobile camera can only be recorded if the setting “Additional mobile camera” is active",
		"ProctoringSettings.ScreenCapture.Title": "Show student computer screen during exam",
		"ProctoringSettings.ScreenCapture.Body": "Shows the student computer screen live during the session.",
		"ProctoringSettings.TrackMetrics.Title": "Track misuse metrics",
		"ProctoringSettings.TrackMetrics.Body1": "Tracks indications of student misuse during the exam based on the following criterias:",
		"ProctoringSettings.TrackMetrics.Body2": "If the webcam is disabled or not.",
		"ProctoringSettings.TrackMetrics.Body3": "If the face of the student is covered or not looking into the webcam.",
		"ProctoringSettings.TrackMetrics.Body4": "If there is more than one face in front of the webcam.",
		"ProctoringSettings.TrackMetrics.Body5": "If the face of the student does not match the initial face photo taken (the face is photographed automatically in the first minutes after the start of the session if face photo at exam start is disabled).",
		"ProctoringSettings.TrackMetrics.Body6": "If the microphone is muted or its volume is low.",
		"ProctoringSettings.TrackMetrics.Body7": "If there is background noise.",
		"ProctoringSettings.TrackMetrics.Body8": "If there is no network connection.",
	};
}());
